/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */
import axios from 'axios';
import moment from 'moment-timezone';
import { Buffer } from 'buffer';

import { Component, createRef } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { FormControl, Button, Modal, OverlayTrigger, Popover, Table, Form, Spinner, Accordion } from "react-bootstrap";
import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";

import { gaID } from 'shared/settings/gaConfig';
import { BID_AMOUNT, CATERGORY } from 'shared/settings/config';
import { addDataLayer, getItemUrl, mergeItemPreviousNextInSessionStorage } from 'shared/utils/utils';
import store from 'features/store';
import { LocationService, ItemsService, InvoiceService } from 'shared/services';
import PersonalInfoService from 'shared/services/PersonalInfoService';
import { dateTimeFormat, stringToHTMLConvert, titleCase } from 'shared/modifiers';
import { handleToken, isAuthorized, logout } from 'shared/settings/auth';
import validators from 'shared/validators';
import { image_thumbnail, loaderIcon } from 'shared/images/images';
import { getBuyerHeaders, getBuyersUrl, getSellerUrl } from 'shared/http';
import { eligibleCategoryandLocation, irmDetails, seelDetailsData, seelGDDetailsData, suspendList } from 'shared/settings/apiconfig';
import { disablePreviousState } from 'shared/settings/stateMaintain';
import { enablePreviousState, estateSaleCategory, removeStateMaintainValue, SaleCardView } from 'shared/settings/stateMaintain';
import { initFbPixel, trackCustomEvent } from 'shared/settings/fbPixelConfig';

import { PayPalClientId } from 'shared/settings/config';
import { Loader } from 'shared/hoc/loader/Loader';
import { eye, LeftArrowLineDimmed, RightArrowLineDimmed,enlargeIcon, RightArrowLine } from 'shared/assets/icons';
import { ItemGalleryHOC } from 'shared/hoc/item-gallery/ItemGalleryHOC';
import PaginationListHOC from '../HOC/PaginationListHOC';
import { COUNTDOWN_TYPE, CountdownHoc } from '../HOC/CountdownHoc';
import { BREADCRUMB_TYPE_CONFIG } from 'shared/hoc/breadcrumbs/config';
import { Breadcrumbs, navigateUsingBreadcrumbs } from 'shared/hoc/breadcrumbs/Breadcrumbs';
import { resetBreadcrumbs } from 'shared/hoc/breadcrumbs/Breadcrumbs';
import { bidEventManager } from 'shared/sse/SSEManager';

import './ItemView.scss';

const getDefaultState = (props) => {
    const state = {
        config: props.payPalPage,
        payPalConfig: {
            script: {
                "client-id": PayPalClientId,
                currency: "USD",
                intent: "capture",
            },
            buttonStyle: {
                shape: 'pill',
                color: 'white',
                layout: 'vertical',
                label: 'checkout',
            }
        },
        steps: 1,
        placebidLoading: false,
        buynowLoading: false,
        invoiceOrderCreated: false,
        paypalbtnDisabled: false,
        windowWidth: window.innerWidth,
        duration: null,
        pageLoading: true,
        itemsDetails: {},
        itemImageList: [],
        isItemClosed: false,
        bidConfirmModal: false,
        itemReciptModel: false,
        irmOptionData: [],
        shippingModel: false,
        bidderCheck: false,
        buyNowConfirmModal: false,
        askAQuestion: false,
        totalPriceForBuyNow: { buynowprice: 0, buyerspremium: 0, taxValue: 0, shippingfee: 0, total: 0, applytaxonbp: 0, taxonbpamount: 0, handlingfee: 0 },
        placeBidForm: {
            amount: { value: '', error: '', validators: [validators.required()] }
        },
        formValid: false,
        messageForm: {
            message: { value: '', error: '', validators: [validators.required(), validators.maxLength(200)] },
            isPublic: { value: "false", error: '', validators: [validators.required()], valid: true }
        },
        messageFormValid: false,
        videoPlayerModal: false,
        bidHistoryModal: false,
        placeBidValue: { total: 0, currentValue: 0, buyerspremiumValue: 0 },
        bidHistory: [],
        bidCount: 0,
        currentBid: 0,
        highestBidder: '-',
        removeBuyNow: false,
        incrementvalue: 1,
        bidError: null,
        bidLoading: false,
        watch: [],
        noImage: false,
        noDataFound: false,
        messageList: [],
        messageLoading: false,
        isVisible: false,
        locationImage: [],
        bidHistoryData: {},
        expandTerms: false,
        buyNowModalHandle: { message: null, loading: false },
        galleryModal: false,
        currentBidLoading: false,
        refreshData: {},
        pageClientWidth: 0,
        estateTermsConditions: false,
        paymentSelectionModal: false,
        paymentConfirmBtn: false,
        paymentConfirmLoading: false,
        paymentError: false,
        prevPath: props?.previousPath?.state?.prevPath,
        shippingto: {
            address: '',
            cityState: '',
            countryZipcode: '',
        },
        buynowItemReceiptValue: '',
        pickupCheckBox: false,
        itemIrm: [],
        suspendedErrorMessage: '',
        confirmBuyNowIrm: true,
        closeBuyNowIrmButton: true,
        payPalMessage: false,
        isreturnassurance: false,
        isdeliveryguarantee: false,
        deliveryInfoModal: false,
        returnAssuranceInfoModal: false,
        bidConfirmModalType: "",
        seelData: '',
        showSeelLoading: false,
        showSeelErrorMessage: '',
        bidderIRMChecked: '',
        raEligibleList: {},
        irmSelected: '',
        seelGDData: '',
        showRAModal: false,
        showGDModal: false,
        showPayment: false,
        dgEligibleList: {},
        showGDSeelLoading: false,
        showGDSeelErrorMessage: '',
        ispremierCredit: false,
        disablePaymentMethod: false,
        suspendList: [],
        configData: {},
        chunkIndexMap: {},
        activeMediaIndex: 0
    };

    return state;
}

class ItemView extends Component {
    constructor(props) {
        super(props);
        this.itemViewRef = createRef(); // item View Ref
        this.toasterMessage = createRef();
        this.galleryModalRef = createRef();
        this.isBackNavigation = false;
        this.checkNext = true;
        this.state = getDefaultState(this.props);

        /* Params data */
        this.userId = this.props.user.id
        this.itemId = this.props?.match?.params?.itemId;
        this.itemTitle = this.props?.match?.params?.itemTitle;
        this.saleId = this.props?.match?.params?.saleId;
        this.previousItemId = false;
        this.nextItemId = false;
        this.nextpageItem = [];

        this.timeoutInterval = null;
        this.conditionsData = [
            {
                condition: "NEW",
                description: "Items show no signs of being worn and include tags, packaging, etc."
            },
            {
                condition: "LIKE NEW",
                description: "Items are clearly unused, but tags are not attached, packaging missing, etc."
            },
            {
                condition: "VERY GOOD",
                description: "Items show minor signs of wear. Example- shoes may have light scuffing on the soles, light scratches."
            },
            {
                condition: "GOOD",
                description: "Items show moderate signs of wear, moderate scuffing or scratches"
            },
            {
                condition: "FAIR",
                description: "Heavy wear, scratches, etc."
            }
        ];
    }

    componentDidMount() {
        this.pageRender();
        this.getitemData();
        document.addEventListener('visibilitychange', this.handleTabChange);
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "itemview" } });
        enablePreviousState();
        window.addEventListener('resize', this.getwindowwidth);
        window.addEventListener("popstate", () => {
            this.isBackNavigation = true;
          });
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.getBidHistory();
            this.getSuspendedList();
            this.getMessageList();
            this.getIrmDetails();
        }
        if (JSON.stringify(prevProps?.match?.params) !== JSON.stringify(this.props?.match?.params)) {
            this.itemId = this.props?.match?.params?.itemId;
            this.itemTitle = this.props?.match?.params?.itemTitle;
            this.saleId = this.props?.match?.params?.saleId;
            this.setState({ pageLoading: true }, () => {
                if (!this.isBackNavigation) {
                  this.pageRender();
                }
                this.isBackNavigation = false; 
              });
          
        }

        if ( JSON.stringify(prevProps.sseItemIds) !== JSON.stringify(this.props.sseItemIds) && Array.isArray(this.props.sseItemIds) && this.props.sseItemIds.includes(parseInt(this.itemId)) ) {
            this.updateBidValue();
            store.dispatch({ type: 'BIDS', payload: [] });
        }
        // document.addEventListener('visibilitychange', this.handleTabChange);
    }

    getitemData = () => {
        let data = {
    
            "field": ["id","displayimageurl","state","city","zipcode","itemstatus","itemtypeid","itemtypename","itemclosetime","utc","title","endtime","isshippable","saleid","category","categoryGroup","thumbnailurl","itemseourl","bidprice","itemlistingtime"],
            "filter": [
                {
                    "field": "salestatus",
                    "value": "Started",
                    "op": "=",
                    "join": "AND"
                },
                {
                    "field": "itemstatus",
                    "value": "Ready",
                    "op": "=",
                    "join": "AND"
                },
                {
                    "field": "saleid",
                    "value": this.saleId,
                    "op": "=",
                    "join": "AND"
                }
            ],
            "page": {"size": 1000},
            "sort":[{"field": "itemclosetime", "direction": "asc"}]
        }
        ItemsService.getItemsList(data).then(response => {
            this.nextpageItem = response.data.data;
          
        }).catch((error) => {
        });
    }

    pageRender = () => {
        try {
            let previousNextSessionData = window.sessionStorage.getItem('previousNext');
            this.previousNext = typeof previousNextSessionData === 'string' ? JSON.parse(previousNextSessionData) : null;
            if ( Array.isArray(this.previousNext?.list) && this.previousNext.list.length > 0 && this.previousNext.currentIndex >= 0 ) {
                if (this.props?.statemaintenance?.EstateItemList) {

                    if (this.previousNext.currentIndex === 0 && this.previousNext.currentPageIndex === 1) {
                        this.previousItemId = false;
                    } else {
                        this.previousItemId = true;
                    }

                    if (this.previousNext.currentIndex === this.previousNext.list.length - 1 && this.previousNext.currentPageIndex === this.previousNext.page) {
                        this.nextItemId = false;
                    } else {
                        this.nextItemId = this.checkNext;
                    }
                }
                else {
                    if (this.previousNext.currentIndex > 0) {
                        this.previousItemId = true;
                    } else {
                        this.previousItemId = false;
                    }

                    if (this.previousNext.currentIndex < this.previousNext.list.length - 1) {
                        this.nextItemId = true;
                    } else {
                        this.nextItemId = false;
                    }
                }

            } else {
                this.previousItemId = false;
                this.nextItemId = false;
            }

            this.getRequiredDetails();
        } catch (error) {
        }
    }

    confirmBuyNowIrm = () => {
        if (this.state.bidderIRMChecked != "" || this.state.bidderIRMChecked != null) {
            this.getPlaceBidSeelData("buynow");
        }
        this.setState({
            confirmBuyNowIrm: false,
            closeBuyNowIrmButton: false,
            payPalMessage: true,

        })
    }
    closeBuyNowConfirm = () => {
        this.setState({
            paymentSelectionModal: false,
            paymentError: false,
            payPalMessage: false,
            buynowItemReceiptValue: '',
            confirmBuyNowIrm: true,
            closeBuyNowIrmButton: true,
            showSeelErrorMessage: '',
            showSeelLoading: false,
            showRAModal: false,
            showGDModal: false,
            showGDSeelLoading: false,
            showGDSeelErrorMessage: ''
        })

    }

    onApprove(data, actions) {
        this.setState({
            paymentSuccess: true,
            paymentUpdated: false
        });

        const item_id = this.itemId;
        const invoicenumber = this.props.payPalPage.moreDetails.invoicenumber;

        const postData = {
            "data": {
                "referencenumber": data['orderID'],
                "amount": this.state.totalPriceForBuyNow.total,
                "credit": 1,
                "paymentmode": "paypal",
                "paymentreference": data['payerID'],
                "status": "completed",
                "partialpayment": 0,
                "buyerid": this.props.user.id,
                "paypal": data,
                "rastatus": this.state.isreturnassurance,
                "gdstatus": this.state.isdeliveryguarantee
            }
        };

        if (this.state.buynowItemReceiptValue) {
            postData.data["invoiceitemreceiptmethod"] = this.state.buynowItemReceiptValue;
        }

        if (item_id) {
            postData.data["comments"] = `${item_id}`;
            postData.data["itemid"] = item_id;
        }



        this.setState({
            postData: postData,
        });
        this.props.history.push({ pathname: '/payment', state: { payPalConfig: this.state.postData }, papaypalstatus: true });
    }
    getDescription = (condition) => {
        const foundCondition = this.conditionsData.find(item => item.condition === condition);
        return foundCondition ? foundCondition.description : '';
    }

    createOrder(data, actions) {
        store.dispatch({
            type: 'PAYPAL_PAYMENT_PAGE',
            payload: {
                amount: this.state.totalPriceForBuyNow.total,
                redirectTo: `/my-account/invoice`,
                moreDetails: {
                    itemId: this.itemId,
                    payee: this.state.itemsDetails.paypalemail,
                    description: `Itemid - ${this.itemId}, Sale id - ${this.state.itemsDetails.saleid}`,
                    reference_id: `Itemid - ${this.itemId}`,
                    isshippable: this.state.itemsDetails.isshippable,
                    buy_now_price: this.state.totalPriceForBuyNow.buynowprice,
                    tax_amount: this.state.totalPriceForBuyNow.taxValue,
                    quantity: 1,
                    item_name: this.state.itemsDetails.title,
                    bpAmount: this.state.totalPriceForBuyNow.buyerspremium,
                    tax_on_BPAmount: this.state.totalPriceForBuyNow.taxonbpamount,
                    amount: this.state.totalPriceForBuyNow.buynowprice,
                    total_amount: this.state.totalPriceForBuyNow.total,
                    sku: this.state.itemsDetails.SKU,
                    shipping: this.state.totalPriceForBuyNow.shippingfee,
                    handling: this.state.totalPriceForBuyNow.handlingfee
                }
            }
        });

        const item_id = this.itemId;
        const invoicenumber = this.props.payPalPage.moreDetails?.invoicenumber;
        if (item_id) {
            return actions.order.create({
                purchase_units: [
                    {
                        description: this.props.payPalPage.moreDetails.description,
                        reference_id: this.props.payPalPage.moreDetails.reference_id,
                        amount: {
                            currency_code: "USD",
                            value: parseFloat(this.state.totalPriceForBuyNow.total),
                            breakdown: {
                                item_total: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.state.totalPriceForBuyNow.total - (this.state.totalPriceForBuyNow.taxValue + this.state.totalPriceForBuyNow.taxonbpamount + this.state.totalPriceForBuyNow.shippingfee + this.state.totalPriceForBuyNow.handlingfee)).toFixed(2))
                                },
                                shipping: {
                                    currency_code: "USD",
                                    value: parseFloat(this.state.totalPriceForBuyNow.shippingfee)
                                },
                                handling: {
                                    currency_code: "USD",
                                    value: parseFloat(this.state.totalPriceForBuyNow.handlingfee)
                                },
                                tax_total: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.state.totalPriceForBuyNow.taxValue + this.state.totalPriceForBuyNow.taxonbpamount).toFixed(2))
                                }
                            }
                        },
                        payee: {
                            email_address: this.state.itemsDetails.paypalemail
                        },
                        application_context: {
                            user_action: "PAY_NOW",  // Button name, can be PAY_NOW or CONTINUE
                        },
                        items: [
                            {
                                name: this.props.payPalPage.moreDetails.item_name,
                                quantity: 1,
                                sku: this.props.payPalPage.moreDetails.sku,
                                tax: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.state.totalPriceForBuyNow.taxValue + this.state.totalPriceForBuyNow.taxonbpamount).toFixed(2))
                                },
                                unit_amount: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.state.totalPriceForBuyNow.total - (this.state.totalPriceForBuyNow.taxValue + this.state.totalPriceForBuyNow.taxonbpamount + this.state.totalPriceForBuyNow.shippingfee + this.state.totalPriceForBuyNow.handlingfee)).toFixed(2))
                                }
                            }
                        ]
                    },
                ],
            }).then(details => {
                const data = {
                    ordernumber: details,
                    itemid: item_id,
                    gateway: "paypal"
                };
                return InvoiceService.createBuynowOrderDetail({ data }).then(orderDetail => {
                    this.setState({ buynowOrderCreated: true, orderDetail: orderDetail.data.data[0] });
                    return details;
                }).catch(error => {
                    if (error.status === 503) {
                        this.serviceDown();
                    } else {
                        this.setState({

                            paymentError: "Oops Something went wrong, please try again or contact CTBids Helpdesk."
                        });
                    }
                    return;
                });
            })

        } else {
            return actions.order.create({
                purchase_units: [
                    {
                        description: this.props.payPalPage.moreDetails.description,
                        reference_id: this.props.payPalPage.moreDetails.reference_id,
                        amount: {
                            value: this.props.payPalPage.amount,
                        },
                        payee: {
                            email_address: this.props.payPalPage.moreDetails.payee
                        },
                        application_context: {
                            user_action: "PAY_NOW",  // Button name, can be PAY_NOW or CONTINUE
                        }
                    },
                ],
            }).then(details => {
                const data = {
                    ordernumber: details,
                    invoiceid: invoicenumber,
                    gateway: "paypal"
                };
                return InvoiceService.createInvoiceOrderDetail({ data }).then(orderDetail => {
                    this.setState({ invoiceOrderCreated: true, orderDetail: orderDetail.data.data[0] });
                    return details;
                }).catch(error => {
                    if (error.status === 503) {
                        this.serviceDown();
                    } else {
                        this.setState({
                            paymentError: "Oops Something went wrong, please try again or contact CTBids Helpdesk."
                        });
                    }
                    return;
                });
            }).catch(error => {
                this.setState({
                    paymentError: "Payment Processing failed. Please try again or contact Seller directly."
                });
                return;
            });

        }
    }
    onCancel = (data) => {
        if (this.state.invoiceOrderCreated) {
            this.cancelInvoiceOrder().then(res => res).catch(error => error);
        }
        if (this.state.buynowOrderCreated) {
            this.cancelBuynowOrder().then(res => res).catch(error => error);
        }
    }
    cancelBuynowOrder = () => {
        const item_id = this.itemId;
        return InvoiceService.cancelBuynowOrder(item_id).then(res => res).catch(error => error);
    }

    getSuspendedList = () => {
        let payload = {
            "filter": [
                { "field": "buyerid", "value": this.props.user.id, "op": "=", "join": "AND" },
                { "field": "locationid", "value": this.state.itemsDetails.locationid, "op": "=", "join": "AND" }
            ]
        }
        axios.post(getBuyersUrl(suspendList), payload, getBuyerHeaders()).then(res => {
            this.setState({
                suspendList: res.data.data
            })
        }).catch(error => {
            return error;
        });
    };

    getTempItemList = () => {
        if ( this.previousNext && Array.isArray(this.previousNext.fullList) && this.previousNext.fullList.length > 0 ) {
            this.setState({
                configData: {
                    list: this.previousNext.fullList.filter(elem => (elem.itemid || elem.id) != this.itemId),
                    type: "StaticItem",
                    history: this.props?.history,
                    horizontailView: true,
                    appendIdsForBidListening: true
                }
            })
        }
    }


    /* Called when the page load */
    getRequiredDetails = () => {

        /**
         *  This condition for handle API call's when click previous & next button.
         *  Just checking current item details with params id. 
         *  Previous details also calling due to component did update. For that this condition using.
         */
        if (this.itemId === this.props?.match?.params?.itemId) {
            /* Getting item details */
            /* Get item images list */
            // this.starttime = new Date().getTime();
            // this.getItemDetails().then(response => {
            Promise.all([this.getItemDetails(), this.getItemImages()]).then(responses => {
                if (responses[0].length == 0) {
                    this.props.history.push("/");
                    return;
                } else if (!this.itemTitle && responses[0][0].itemseourl) {
                    this.props.history.replace(getItemUrl(this.saleId, this.itemId, responses[0][0].itemseourl));
                }
                const itemDetailResponse = responses[0][0]
                const tempImageList = responses[1].length > 0 ? responses[1] : [{ url: image_thumbnail, type: "image" }];
                const index = tempImageList.findIndex(x => x.isdisplayimage === 1);
                if (index !== -1 && index !== 0) {
                    let temp = tempImageList[index];
                    tempImageList[index] = tempImageList[0];
                    tempImageList[0] = temp;
                }

                this.setState({
                    ...this.state,
                    itemsDetails: itemDetailResponse,
                    itemImageList: tempImageList,
                    noImage: responses[1].length === 0,
                    pageLoading: false,
                }, () => {
                    bidEventManager.connect([parseInt(this.itemId)]);

                    this.getWatchList();
                    this.getLocationImageList();
                    if (isAuthorized()) {
                        this.getBidHistory();
                        this.getIrmDetails();
                        this.getSuspendedList();
                    } else {
                        this.getCurrentBidValue();
                    }
                    this.getTempItemList();
                    this.getMessageList();
                    this.getEligibleCategoryandLocation();
                });

                const analyticsParam = {
                    'page_title': 'Item-View',
                    'page_path': this.props.location.pathname
                };
                // google analytics config for item detail page
                window.gtag('config', gaID, analyticsParam);
                if (itemDetailResponse['googlecode']) {
                    window.gtag('config', itemDetailResponse['googlecode'], analyticsParam);
                }

                trackCustomEvent("ItemView", analyticsParam);
                const fbpixel = itemDetailResponse?.['fbpixel'];
                if (fbpixel) {
                    initFbPixel(fbpixel);
                    trackCustomEvent("ItemView", analyticsParam, fbpixel);
                }
                ItemsService.addCountAPI(this.itemId).then(Res => Res).catch(err => err);
            }).catch(error => {
                this.setState({
                    noDataFound: true,
                    pageLoading: false
                });
            });
        }
    }

    getItemDetails = async (value) => {
        if (value) {
            this.setState({
                placebidLoading: true,
            })
        }
        const itemsDetailsGet = {
            "sort": [
                { "field": "title", "direction": "asc" }
            ],
            "filter": this.itemTitle ? [
                { "field": "itemseourl", "value": this.itemTitle, "op": "=", "join": "AND" },
                { "field": "saleid", "value": this.saleId, "op": "=", "join": "AND" },
                { "field": "itemid", "value": this.itemId, "op": "=", "join": "AND" }] : [
                { "field": "saleid", "value": this.saleId, "op": "=", "join": "AND" },
                { "field": "itemid", "value": this.itemId, "op": "=", "join": "AND" }
            ]
        };

        return new Promise((resolve, reject) => {
            ItemsService.getItemDetails(this.itemId, itemsDetailsGet).then(
                itemsDetail => {
                    resolve(itemsDetail.data.data);
                    let valuecheck = JSON.parse(itemsDetail.data?.data[0]?.itemreceiptmethod);
                    const irmvalue = valuecheck ? Object.keys(valuecheck).filter(key => valuecheck[key] === true) : ['pickup'];
                    this.setState({
                        itemIrm: irmvalue,
                        placebidLoading: false,
                    })
                }
            ).catch((error) => {
                // TODO: Error message handle
                this.setState({
                    placebidLoading: false,
                })
                reject(error);
            });
        });
    }

    getItemImages = async () => {
        const imageListPostData = {
            "filter": [{ "field": "itemid", "value": this.itemId, "op": "=", "join": "AND" }],
            "field": ["id", "name", "type", "url", "itemid", "isdisplayimage", "displayorder", "thumbnailurl"],
            "sort": [{ "field": "displayorder", "direction": "asc" }],
            "page": { "size": 1000 }
        };

        return new Promise((resolve, reject) => {
            ItemsService.getItemImagesList(imageListPostData).then(imageList => {
                resolve(imageList.data.data);
            }).catch(error => {
                reject(error);
            });
        });

    }

    /* Called when buy now button click */
    buyNow = () => {
        if (isAuthorized()) {
            this.shippingAddressCheck();
            this.setState({
                buyNowConfirmModal: true,
                buyNowModalHandle: { message: null, loading: true }
            }, () => {
                ItemsService.getItemBuyNowPrice(this.itemId).then(
                    res => {
                        const data = res.data.data;
                        const buyNow = data.buynowprice ? data.buynowprice : 0;
                        const shippingfee = data.shippingfee ? data.shippingfee : 0;
                        const handlingfee = data.handlingfee ? data.handlingfee : 0;
                        const applytaxonbp = data.applytaxonbp ? data.applytaxonbp : 0;
                        const taxonbpamount = data.taxonBPAmount ? data.taxonBPAmount : 0;
                        const buyerspremiumValue = data.buyerspremiumamount;
                        const taxValue = data.taxamount;
                        const total = data.amount ? data.amount : parseFloat(buyNow + buyerspremiumValue + taxValue + shippingfee + handlingfee + taxonbpamount).toFixed(2);

                        this.setState({
                            totalPriceForBuyNow: {
                                buynowprice: buyNow,
                                buyerspremium: buyerspremiumValue,
                                taxValue: taxValue,
                                handlingfee: handlingfee,
                                shippingfee: shippingfee,
                                applytaxonbp: applytaxonbp,
                                taxonbpamount: taxonbpamount,
                                total: total,
                            },
                            buyNowModalHandle: { message: null, loading: false }
                        });
                    }
                ).catch(
                    error => {
                        if (error.status === 401) {
                            const encoded = Buffer.from(this.props.history.location.pathname).toString("base64");
                            logout(this.props.history, true, encoded);
                            store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                            this.setState({
                                buyNowConfirmModal: false,
                                buyNowModalHandle: { message: null, loading: false }
                            });
                        } else {
                            this.setState({
                                buyNowModalHandle: { message: error.message, loading: false }
                            });
                        }
                    }
                );
            });

        } else {
            this.signIn();
        }
        if (this.watching()) {
            let dataLayerData = {
                'event': 'buy_now',
                'title': this.state.itemsDetails.title
            }
            addDataLayer(dataLayerData)
        }
    }

    closeConfirmModal = () => {
        this.setState({
            steps: 1,
            itemReceiptValue: '',
            totalPriceForBuyNow: { buynowprice: 0, buyerspremium: 0, taxValue: 0, shippingfee: 0, total: 0, applytaxonbp: 0, taxonbpamount: 0, handlingfee: 0 },
            placeBidValue: { total: 0, currentValue: 0, buyerspremiumValue: 0 },
            buyNowConfirmModal: false,
            bidConfirmModal: false,
            askAQuestion: false,
            bidError: null,
            bidLoading: false,
            estateTermsConditions: false,
            paymentSelectionModal: false,
            paymentConfirmBtn: false,
            paymentError: false,
            itemReciptModel: false,
            shippingModel: false,
            pickupModel: false,
            suspendedErrorMessage: '',
            deliveryInfoModal: false,
            returnAssuranceInfoModal: false,
            isreturnassurance: false,
            showSeelErrorMessage: '',
            showSeelLoading: false,
            isdeliveryguarantee: false,
            showRAModal: false,
            showGDModal: false,
            showGDSeelLoading: false,
            showGDSeelErrorMessage: '',
            disablePaymentMethod: false,
            messageForm: {
                ...this.state.messageForm,
                message: { ...this.state.messageForm.message, value: '' },
                isPublic: { ...this.state.messageForm.isPublic, value: "false" }
            }
        });
    }

    /* Called when confirm button click */
    confirmBuyNow = (paymentData) => {
        this.setState({
            paymentConfirmLoading: true,
            paymentConfirmBtn: true
        }, () => {
            if (isAuthorized() && paymentData == "autodebit") {
                const data = {
                    "data": {
                        "itemid": this.itemId,
                        "amount": this.state.totalPriceForBuyNow.total,
                        "invoiceitemreceiptmethod": this.state.buynowItemReceiptValue,
                        "rastatus": this.state.isreturnassurance,
                        "gdstatus": this.state.isdeliveryguarantee
                    }
                };
                this.setState({
                    paypalbtnDisabled: true,
                })
                ItemsService.autoDebit(data).then(data => {
                    if (data.data.status.toLowerCase() === 'success') {
                        this.setState({
                            paymentSelectionModal: false,
                            paymentConfirmLoading: false,
                            paymentConfirmBtn: false
                        });
                    }
                    this.props.history.push({ pathname: '/payment-autodebit', state: { autoDebitAmount: this.state.totalPriceForBuyNow.total } });
                }).catch((error) => {
                    this.setState({
                        paypalbtnDisabled: false,
                        paymentError: error.message,
                        paymentConfirmBtn: false,
                        paymentConfirmLoading: false
                    })
                });
            } else if (isAuthorized() && paymentData == "paypal") {
                store.dispatch({
                    type: 'PAYPAL_PAYMENT_PAGE',
                    payload: {
                        amount: this.state.totalPriceForBuyNow.total,
                        redirectTo: `/my-account/invoice`,
                        moreDetails: {
                            itemId: this.itemId,
                            payee: this.state.itemsDetails.paypalemail,
                            description: `Itemid - ${this.itemId}, Sale id - ${this.state.itemsDetails.saleid}`,
                            reference_id: `Itemid - ${this.itemId}`,
                            isshippable: this.state.itemsDetails.isshippable,
                            buy_now_price: this.state.totalPriceForBuyNow.buynowprice,
                            tax_amount: this.state.totalPriceForBuyNow.taxValue,
                            quantity: 1,
                            item_name: this.state.itemsDetails.title,
                            tax_on_BPAmount: this.state.totalPriceForBuyNow.taxonbpamount,
                            bpAmount: this.state.totalPriceForBuyNow.buyerspremium,
                            amount: this.state.totalPriceForBuyNow.buynowprice,
                            total_amount: this.state.totalPriceForBuyNow.total,
                            sku: this.state.itemsDetails.SKU,
                            shipping: this.state.totalPriceForBuyNow.shippingfee,
                            handling: this.state.totalPriceForBuyNow.handlingfee
                        }
                    }
                });
                this.props.history.push('/payment');
            } else {
                this.signIn();
            }
        })
    }

    back = () => {
        enablePreviousState();
        if (this.props.onBackClick) {
            this.props.onBackClick();
        } else {
            this.props.history.goBack();
        }
    }

    htmlTextConverter = (htmlObj, sectionKey) => {
        let fullHtml = '';
      
        // Case 1: HTML structure with content.body
        if (typeof htmlObj === 'string') {
          try {
            const parsed = JSON.parse(htmlObj);
            fullHtml = parsed?.content?.body || htmlObj; // fallback to string
          } catch {
            fullHtml = htmlObj; // plain string
          }
        } else {
          fullHtml = htmlObj?.content?.body || '';
        }
      
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<div>${fullHtml}</div>`, 'text/html');
        const clone = doc.body.cloneNode(true);
        const walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT, null, false);
      
        const chunkIndexMap = this.state.chunkIndexMap || {};
        const currentChunkIndex = chunkIndexMap[sectionKey] || 1;
        const wordLimit = currentChunkIndex * 120;
      
        let wordCount = 0;
        let reachedLimit = false;
      
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const words = node.textContent.trim().split(/\s+/);
      
          if (wordCount + words.length >= wordLimit) {
            const allowed = wordLimit - wordCount;
            node.textContent = words.slice(0, allowed).join(' ');
            wordCount += allowed;
            reachedLimit = true;
      
            let n = node;
            while (n && n !== clone) {
              while (n.nextSibling) {
                n.parentNode.removeChild(n.nextSibling);
              }
              n = n.parentNode;
            }
            break;
          } else {
            wordCount += words.length;
          }
        }
      
        const partialHtml = clone.innerHTML;
      
        return (
          <div className="message-wrap">
            <div className='description-content' dangerouslySetInnerHTML={{ __html: partialHtml }} />
            {reachedLimit && (
              <button
                className="mt-3 p-0"
                style={{
                  border: 'none',
                  backgroundColor: 'white',
                  color: '#1D8296',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  this.setState((prevState) => ({
                    chunkIndexMap: {
                      ...prevState.chunkIndexMap,
                      [sectionKey]: currentChunkIndex + 1,
                    },
                  }))
                }
              >
                More <span style={{ color: '#868E96', fontSize: '16px' }}>+</span>
              </button>
            )}
          </div>
        );
      };
      
      

    estateSale = () => {
        const { statemaintenance, dispatch } = this.props;
        let pusttoStore = { ...statemaintenance };
        pusttoStore["EstateItemList"] = {
            ...pusttoStore?.["EstateItemList"],
            scrollindex: 0
        };
        dispatch({
            type: 'PUSH_TO_STATE',
            payload: pusttoStore
        });
        navigateUsingBreadcrumbs(this.props.history, `/estate-sale/${this.state.itemsDetails.saleid}`);
        // resetBreadcrumbs()
    }

    formatDate = () => {
        return dateTimeFormat(this.state.itemsDetails.itemclosetime);
        // return moment(this.state.itemsDetails.itemclosetime).format('MM/DD/YYYY');
    }

    setPlacebidValue = async (callSeel = true) => {
        const confirm_amount = this.state.placeBidForm.amount.value;
        const buyerspremium = this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0;
        const buyerspremiumValue = parseFloat((confirm_amount / 100) * buyerspremium).toFixed(2);
        const total = parseFloat(parseFloat(confirm_amount)).toFixed(2);
        this.getItemDetails(true);
        if (callSeel && this.state.bidderCheck && !(parseFloat(this.state.placeBidForm.amount.value) < parseFloat(this.state.currentBid + this.state.incrementvalue)) && (this.state.bidderIRMChecked != "" || this.state.bidderIRMChecked != null)) {
            this.getSeelDetails();
            this.getSeelGDDetails();
        }

        this.setState({
            bidConfirmModal: this.state.itemReciptModel ? false : true,
            placeBidValue: { total: total, currentValue: confirm_amount, buyerspremiumValue: buyerspremiumValue }
        })
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName, count = null, validControl = "formValid", isCheckBox = false) => {
        let controlError = '';

        if (isCheckBox) {
            event.target.value = event.target.checked;
        }
        /* Decimal value check */
        if (event.target.name === 'amount') {
            event.target.value = event.target.value.replace(/[^0-9.]/g, '')
            let value = event.target.value
            const checkvalue = (value.match(/\./g) || []).length;

            if (value.length == 1 && value.includes('.')) {
                event.target.value = ''
            }
            if (checkvalue > 1) {
                return;
            }

            if (event.target.value.includes('.') && event.target.value.split('.')[1].length > 2) {
                return;
            }
            if (this.timeoutInterval) {
                clearTimeout(this.timeoutInterval);
            }
            this.timeoutInterval = setTimeout(() => {
                if (event.target.value) {
                    var a = parseFloat(event.target.value).toFixed(2)

                    const parts = a.split('.');

                    let formattedValue = '';
                    if (parts.length >= 1) {
                        formattedValue += parts[0];
                    }
                    if (parts.length >= 2) {
                        formattedValue += '.' + parts[1].slice(0, 2);
                    }

                    const dotCount = (formattedValue.match(/\./g) || []).length;
                    if (dotCount > 1) {
                        const dotIndex = formattedValue.indexOf('.');
                        formattedValue = formattedValue.slice(0, dotIndex + 1) + formattedValue.slice(dotIndex + 1).replace(/\./g, '');
                    }
                    this.setState({
                        [formName]: {
                            ...this.state[formName],
                            [event.target.name]: {
                                ...this.state[formName][event.target.name],
                                value: formattedValue,
                            }
                        }

                    }, () => {
                        if (this.state.bidConfirmModal) {
                            this.setPlacebidValue(false);
                        }
                    })

                }
            }, 2000);
        } else if (event.target.value.indexOf('.') !== -1 && count) {
            if ((event.target.value.length - event.target.value.indexOf('.')) > count) {
                event.target.value = parseFloat(event.target.value).toFixed(count);
            }
        }

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ [validControl]: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ [validControl]: formValid });
                }
            });
    }

    placeBidConfirmModal = async () => {
        if (isAuthorized()) {
            const confirm_amount = this.state.placeBidForm.amount.value;
            const buyerspremium = this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0;
            const buyerspremiumValue = parseFloat((confirm_amount / 100) * buyerspremium).toFixed(2);
            const total = parseFloat(parseFloat(confirm_amount)).toFixed(2);
            await this.getItemDetails(true)
            this.shippingAddressCheck();
            this.setState({
                irmOptionData: this.state.itemIrm,
                itemReceiptValue: this.state.itemReceiptValue == "pickup" ? "pickup" : this.state.itemIrm.includes('pickup') && this.state.itemIrm.length === 1 ? 'pickup' : '',
                itemReciptModel: this.state.itemIrm.length === 0 || !this.state.bidderCheck ? true : false,
                pickupModel: this.state.itemIrm.includes('pickup') && this.state.itemIrm.length === 1 ? true : false,
                // bidConfirmModal: true,
                placeBidValue: { total: total, currentValue: confirm_amount, buyerspremiumValue: buyerspremiumValue }
            }, () => {
                this.setPlacebidValue();
            });
        } else {
            this.signIn();
        }
        let dataLayerData = {
            'event': 'place_bid',
            'title': this.state.itemsDetails.title,
            'placebidamount': this.state.placeBidForm.amount.value,
        }
        addDataLayer(dataLayerData)
    }

    confirmIrmMethod = () => {
        this.setState({
            steps: this.state.steps + 1
        })
        if (this.state.itemReceiptValue === "shipping" || this.state.itemReceiptValue === "delivery") {
            this.setState({
                shippingModel: true,
                itemReciptModel: false,
                bidConfirmModal: false,
            })
        }
        else {

            this.setState({
                itemReciptModel: false,
                shippingModel: false,
                bidConfirmModal: true
            })
        }
        if (this.state.bidderIRMChecked != "" || this.state.bidderIRMChecked != null) {
            this.getPlaceBidSeelData();
        }
    }

    confirmShippingMethod = () => {

        this.setState({
            steps: this.state.steps + 1,
            shippingModel: false,
            itemReciptModel: false,
            bidConfirmModal: true,
        })

    }

    onChangeOption = (event) => {
        this.setState({
            itemReceiptValue: event.target.value,
        })
    }
    onChangeBuynowIrm = (event) => {
        if (event.target.type === 'checkbox') {
            event.target.value = event.target.checked ? 'pickup' : ''
        }
        this.setState({
            buynowItemReceiptValue: event.target.value,
            pickupCheckBox: event.target.type === 'checkbox' ? event.target.checked : false
        })
    }

    shippingAddressCheck = () => {
        let data = {
            "sort": [{ "field": "shipping", "direction": "desc" }],
            "filter": [
                {
                    "field": "addressisactive",
                    "value": 1,
                    "op": "AND",
                    "join": "="
                },
                {
                    "field": "shipping",
                    "value": 1,
                    "op": "AND",
                    "join": "="
                }
            ],
            "page": { "size": 10 }
        }

        PersonalInfoService.shippingAddressList(data).then(response => {
            let data = response.data.data[0]
            let shippingtoCityDelimiter = data.city && data.state ? ', ' : '';
            let shippingtoCountryDelimiter = data.country && data.zipcode ? ', ' : '';
            this.setState({
                shippingto: {
                    address: (data?.address1 ? data?.address1 + ', ' : '') + (data?.address2 ? data?.address2 + ', ' : ''),
                    cityState: (data?.city ? data?.city : '') + (shippingtoCityDelimiter) + (data?.state ? data?.state : ''),
                    countryZipcode: (data?.country ? data?.country : '') + (shippingtoCountryDelimiter) + (data?.zipcode ? data?.zipcode : ''),

                },
            })
        }).catch(error => {
            this.setState({

            })

        });
    }

    irmValueUpdated = () => {
        if (this.state.itemReceiptValue) {
            const irmData = {
                "data": {
                    "saleid": this.saleId,
                    "itemreceiptmethod": this.state.itemReceiptValue,
                    "itemid": this.itemId
                }
            }
            ItemsService.ItemReceiptAdd(irmData).then(data => {
                let value = data.data.status
            }).catch((error) => {
                this.setState({
                    itemReciptModel: false,
                    shippingModel: false,
                })
            });
        }

    }

    captializeLetter = (data) => {
        const capitalized = data.charAt(0).toUpperCase() + data.slice(1);
        return capitalized;
    }


    signIn = () => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In',itemview: true } });
    }

    /* Called when click confirm place bid */
    confirmPlaceBid = () => {
        this.setState({
            bidError: null,
            bidLoading: true,
        }, () => {
            const data = {
                "data": [{
                    "itemid": this.itemId,
                    "bidprice": parseFloat(parseFloat(this.state.placeBidValue.total).toFixed(2)),
                    "rastatus": this.state.isreturnassurance,
                    "itemreceiptmethod": this.state.itemReceiptValue,
                    "gdstatus": this.state.isdeliveryguarantee
                }]
            };
            ItemsService.placeBid(data).then(
                placeBid => {
                    this.setState({
                        bidError: null,
                        bidLoading: false,
                        placeBidForm: {
                            ...this.state.placeBidForm,
                            amount: {
                                ...this.state.placeBidForm.amount,
                                value: ''
                            }
                        },
                        bidderIRMChecked: this.state.itemReceiptValue ? this.state.itemReceiptValue : this.state.bidderIRMChecked
                    }, () => {
                        this.getBidHistory(true);
                        if (this.state.irmOptionData[0] !== "") {
                            this.irmValueUpdated()
                        }
                    });
                }
            ).catch((error) => {
                if (error.status === 401) {
                    const encoded = Buffer.from(this.props.history.location.pathname).toString("base64");
                    logout(this.props.history, true, encoded);
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    this.setState({
                        bidConfirmModal: false,
                        steps: 1
                    });
                }
                this.setState({
                    bidError: error.message,
                    bidLoading: false,
                })
                // TODO: Error message handle
            });
        });
    }

    updateBidValue = () => {
        try {
            if (isAuthorized()) {
                if (this.state.itemsDetails.itemtypeid === 2) {
                    this.getBidHistory();
                } else {
                    this.getCurrentBidValue();
                }
            } else {
                this.getCurrentBidValue();
            }
        } catch (e) {
            console.error(e);
        }
    }

    getBidHistory = (closeConfirm = false) => {
        if (this.state.itemsDetails.itemtypeid === 2) {
            this.setState({
                currentBidLoading: true
            }, () => {
                ItemsService.getBidHistory(this.itemId).then(
                    responseData => {
                        const bidHistoryData = responseData?.data?.data || {};
                        const bidHistory = bidHistoryData?.bidhistory || [];
                        this.setState({
                            ...this.state,
                            itemsDetails: {
                                ...this.state.itemsDetails,
                                itemclosetime: bidHistoryData.itemclosetime
                            },
                            bidHistory,
                            currentBid: bidHistory?.length > 0 ? bidHistory?.[0]?.bidprice : 0,
                            incrementvalue: bidHistoryData?.incrementvalue ? bidHistoryData?.incrementvalue : 1,
                            highestBidder: bidHistory?.length > 0 ? bidHistory?.[0]?.nickname : '-',
                            bidHistoryData,
                            isItemClosed: bidHistoryData.bidstatus === 'Closed',
                            currentBidLoading: false
                        }, () => {
                            this.checkbidhistory();
                            this.removeBuyNow();
                        });

                        if (closeConfirm) {
                            this.toasterMessage.current?.showMessage({ type: 'success', message: 'Bid Placed Successfully' });
                            this.closeConfirmModal();
                        }
                    }
                ).catch((error) => {
                    // TODO: Error message handle
                    if (error.status === 401) {
                        const encoded = Buffer.from(this.props.history.location.pathname).toString("base64");
                        logout(this.props.history, true, encoded);
                        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    }
                    this.removeBuyNow();
                });
            });
        }
    }

    getCurrentBidValue = () => {
        this.setState({
            currentBidLoading: true
        }, () => {
            const data = {
                "data": {
                    "itemIds": [this.itemId]
                }
            };
            ItemsService.getCurrentBidValue(data).then(
                response => {
                    const currentBidValue = response?.data?.data;
                    this.setState({
                        currentBidLoading: false,
                        itemsDetails: {
                            ...this.state.itemsDetails,
                            itemclosetime: currentBidValue?.length > 0 ? currentBidValue?.[0]?.itemclosetime : this.state.itemsDetails.itemclosetime
                        },
                        currentBid: currentBidValue?.length > 0 ? currentBidValue?.[0]?.bidprice : 0,
                        incrementvalue: currentBidValue?.length > 0 ? currentBidValue?.[0]?.incrementvalue : 0,
                        isItemClosed: currentBidValue?.length > 0 ? currentBidValue?.[0]?.bidstatus === 'Closed' : false,
                        bidCount: currentBidValue?.length > 0 ? currentBidValue?.[0]?.bidcount : 0
                    });
                }
            ).catch(error => {
                this.setState({
                    currentBidLoading: false
                });
            });
        });
    }

    askAQuestionModal = () => {
        this.setState({
            askAQuestion: true
        });
    }

    /**
     * 
     * @param {string} direction either Up or Down 
     */
    scrollToItemView = (direction) => {
        const top = direction === 'Up' ? 0 : this.itemViewRef.current.scrollHeight;
        this.itemViewRef.current.scrollTo({ top: top, left: 0, behavior: 'smooth' });
    }  

    bidHistoryModalToggle = () => {
        this.setState({
            bidHistoryModal: !this.state.bidHistoryModal
        })
    }

    moreSale = () => {
        disablePreviousState();
        const LocationUrl = this.state.itemsDetails.locationcode ? `/estate-sales/${this.state.itemsDetails.locationstatecode}/${this.state.itemsDetails.locationcode}` : `/estate-sales/${this.state.itemsDetails.locationstatecode}`;
        this.props.history.push(LocationUrl);
    }

    watch = (event) => {
        event.stopPropagation();
        const itemId = this.state.itemsDetails.id;
        this[`buttonDOM`].blur();
        if (isAuthorized()) {
            const index = this.state.watch.findIndex(x => x.itemid === itemId);
            if (index !== -1) {
                const removeData = {
                    "data": {
                        "itemIds": [itemId]
                    }
                };
                ItemsService.removeFromWatch(removeData).then(
                    response => {
                        this.getWatchList();
                    }
                ).catch((error) => {
                    this.getWatchList();
                });
            } else {
                const addData = {
                    "data": [
                        {
                            "itemid": itemId
                        }
                    ]
                }
                ItemsService.addToWatch(addData).then(
                    response => {
                        this.getWatchList();
                    }
                ).catch((error) => {
                    this.getWatchList();
                });
            }
        } else {
            this.signIn();
        }
        let dataLayerData = {
            'event': 'watch',
            'title': this.state.itemsDetails.title
        }
        addDataLayer(dataLayerData)
    }

    getWatchList = () => {
        if (isAuthorized()) {
            const data = {
                "field": ["itemid"],
                "sort": [{ "field": "id", "direction": "desc" }],
                "filter": [{ "field": "itemid", "value": this.state.itemsDetails.id, "op": "=", "join": "AND" }],
            };
            ItemsService.getWatchListItem(data).then(
                response => {
                    this.setState({
                        watch: response.data.data
                    });
                }
            ).catch(error => {

            });
        }
    }

    getLocationImageList = () => {
        const locationImageData = { "filter": [{ "field": "locationid", "value": this.state.itemsDetails.locationid, "op": "=", "join": "AND" }] }
        LocationService.getLocationImagesList(locationImageData).then(
            locationImage => {
                this.setState({
                    locationImage: locationImage.data.data
                });
            }
        ).catch(error => {

        });
    }

    watching = (items) => {
        const itemId = this.state.itemsDetails.id;
        return this.state.watch.filter(x => x.itemid === itemId).length > 0;
    }

    removeBuyNow = () => {
        const currentBid = this.state.currentBid;
        const buyNowPrice = this.state.itemsDetails.buynowprice;
        const getAmount = (buyNowPrice / 100) * 75;
        const removeBuyNow = this.state.itemsDetails.itemtypeid < 3 ? getAmount <= currentBid : false;
        this.setState({
            removeBuyNow: this.state.itemsDetails.itemstatus !== "Ready" ? true : removeBuyNow
        });
    }

    profileComplete = () => {
        this.props.history.push(`/my-account/my-info/personal-info`, {
            previouspath: this.props.location.pathname,
            name: "bidscreen"
        });
    }

    paymentComplete = () => {
        this.props.history.push(`/my-account/my-info/payment-methods/add`, {
            previouspath: this.props.location.pathname,
            name: "bidscreen"
        });
    }

    getMessageList = () => {
        const data = {
            "page": {
                "size": 10
            },
            "filter": [
                { "field": "itemid", "value": parseInt(this.itemId), "op": "=", "join": "AND" }
            ]
        };
        ItemsService.getMessageList(data).then(
            response => {
                const temp = response.data.data;
                temp.map((reply) => {
                    if (reply['reply'].length > 0) {
                        reply['reply'] = reply['reply'];
                    } else {
                        reply['reply'] = [];
                    }
                })
                this.setState({
                    messageList: temp
                });
            }
        ).catch(error => {
            this.setState({
                messageList: []
            });
        });
    }

    sendMessage = () => {
        this.setState({
            messageLoading: true
        }, () => {
            const messageForm = this.state.messageForm;
            const data = {
                "message": messageForm.message.value,
                "itemid": this.itemId,
                "buyerid": this.props.user.id,
                "ispublic": messageForm.isPublic.value === "false" ? 1 : 0,
                "selleremail": this.state.itemsDetails.contactemail,
                "subject": "Question regarding listing with title " + this.state.itemsDetails.title,
            };
            ItemsService.sendMessage({ data }).then(
                response => {
                    this.setState({
                        messageLoading: false,
                        messageFormValid: false
                    });
                    this.closeConfirmModal();
                    this.getMessageList();
                }
            ).catch(error => {
                if (error.status === 400) {
                    this.setState({
                        messageLoading: false,
                        suspendedErrorMessage: error.message,
                        messageFormValid: false
                    });
                }
            });
        });
    }

    /* Called when scroll content */
    handleScroll = (event) => {
        try {
            this.setState({
                isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                pageClientWidth: this.itemViewRef.current.clientWidth
            });
        } catch (e) {
            this.setState({
                isVisible: false
            });
        }
    };

    handleTabChange = () => {
        if (document.hidden) {
            // tab is now inactive // temporarily clear timer using clearInterval() / clearTimeout()
        } else {
            // tab is active again // restart timers
            if (isAuthorized()) {
                handleToken().then(Res => Res).catch(Err => Err);
            }
            // this.getUtc();
        }
    }

    getwindowwidth = () => {
        this.setState({
            windowWidth: window.innerWidth,
            pageClientWidth: this.itemViewRef.current.clientWidth
        });
    }

    componentWillUnmount() {
        bidEventManager.ignore();

        window.removeEventListener('resize', this.getwindowwidth);
        document.removeEventListener('visibilitychange', this.handleTabChange);

        window.sessionStorage.removeItem("previousNext");

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    onCloseSomethingWentWrongModal = () => this.setState({
        refreshData: {}
    })

    onRefreshSomethingWentWrongModal = () => {
        const refreshFunction = this.state.refreshData?.func;
        const params = this.state.refreshData?.params;
        if (typeof refreshFunction === 'function' && Array.isArray(params)) {
            refreshFunction(...params)
        }
        this.onCloseSomethingWentWrongModal();
    }

    onPreviousNextClick = (isPrevious) => {
        var index = isPrevious ? this.previousNext.currentIndex - 1 : this.previousNext.currentIndex + 1;
        if (this.props?.statemaintenance?.EstateItemList) {
            let itemBackValid = isPrevious ? 46 : 48
            if (this.previousNext.currentPageIndex > 1 && index <= itemBackValid) {
                let indexadd = (48 * (this.previousNext.currentPageIndex - 1))
                index = index + indexadd
            }

            var pageindex = this.previousNext.currentPageIndex
            if (index < 48) {
                pageindex = 1
            }
            if (index === this.nextpageItem?.length) {
                index = 0
                pageindex = 0
                this.checkNext = false
                
            }
            this.checkNext = true
            if (index === this.nextpageItem?.length - 1) {
                this.checkNext = false
            }
            var item = this.nextpageItem[index];
            mergeItemPreviousNextInSessionStorage (index < 48  ? this.previousNext.list : this.nextpageItem, index, pageindex);

        } else {
            var item = this.previousNext.list[index];
            mergeItemPreviousNextInSessionStorage(this.previousNext.list, index);

        }
        const itemid = item.id ? item.id : item.itemid;


        if ( this.timeoutInterval ) {
            clearTimeout(this.timeoutInterval);
        }
        this.setState(getDefaultState(this.props), () => this.props.history.replace(getItemUrl(item.saleid, itemid, item.itemseourl)));
    }

    getCloseinDatetime = (dateTime) => {
        if (dateTime) {
            const formatedDate = moment.utc(dateTime).local();
            let returnValue = formatedDate.format('MM/DD/YYYY hh:mm:ss A');
            let timeZone = moment.tz(moment.tz.guess()).zoneAbbr();

            return `${returnValue} ${timeZone}`;
        } else {
            return '- - -';
        }
    }

    showTermsAndCondition = () => {
        this.setState({
            expandTerms: !this.state.expandTerms,
            estateTermsConditions: true
        })
    }

    handleCloseTerms = () => {
        this.setState({
            estateTermsConditions: false
        })
    }

    confirmPaymentSelection = async (value) => {
        this.setState({
            buynowLoading: true,
        })
        await this.getItemDetails()
        var currentDate = moment().utc().format('YYYY-MM-DD HH:mm:ss');
        const cardData = {
            "field": ["id"],
            "filter": [
                { "field": "isdefault", "value": 1, "op": "=", "join": "AND" },
                { "field": "cardexpirydate", "value": currentDate, "op": ">", "join": "OR" },
                { "field": "cardtype", "value": "Paypal", "op": "=", "join": "OR" }
            ]
        }
        ItemsService.autoDebitVaultList(cardData).then(response => {
            if (response.data.status.toLowerCase() == "success") {
                if (response.data.data.length > 0) {
                    this.setState({
                        buynowLoading: false,
                        buyNowConfirmModal: false,
                        paymentSelectionModal: true
                    })
                } else {
                    // this.confirmBuyNow("paypal")
                    this.setState({
                        buynowLoading: false,
                        buyNowConfirmModal: false,
                        paymentSelectionModal: true,
                        disablePaymentMethod: true
                    })
                }
            }
        }).catch(() => {
            this.confirmBuyNow("paypal")
            this.setState({
                buynowLoading: false,
            })
        })
    }

    handleClose = () => {
        this.setState({
            paymentSelectionModal: false,
            paymentError: false,
            payPalMessage: false,
            buynowItemReceiptValue: '',
            confirmBuyNowIrm: true,
            closeBuyNowIrmButton: true,
            isreturnassurance: false,
            showSeelErrorMessage: '',
            showSeelLoading: false,
            isdeliveryguarantee: false,
            showRAModal: false,
            showGDModal: false,
            showGDSeelLoading: false,
            showGDSeelErrorMessage: ''
        })
    }

    changeDeliveryGuarantee = (event) => {
        this.setState({
            isdeliveryguarantee: event.target.checked,
        })
    }

    changeReturnAssurance = (event) => {
        this.setState({
            isreturnassurance: event.target.checked
        })
    };

    openDeliveryInfoModal = (type) => {
        this.setState({
            bidConfirmModal: false,
            buyNowConfirmModal: false,
            paymentSelectionModal: false,
            deliveryInfoModal: true,
            bidConfirmModalType: type
        })
    }

    openRAInfoModal = (type) => {
        this.setState({
            bidConfirmModal: false,
            buyNowConfirmModal: false,
            paymentSelectionModal: false,
            returnAssuranceInfoModal: true,
            bidConfirmModalType: type
        })
    }

    checkbidhistory() {
        let bidhistorydata = this.state.bidHistory
        if (bidhistorydata.length > 0) {
            bidhistorydata.map((bidderid) => {
                if (bidderid.buyerid === this.props.user.id) {
                    this.setState({
                        bidderCheck: true
                    })
                }
            })
        } else {
            this.setState({
                bidderCheck: false
            })
        }

    }

    closeSeelInfoModal = (type) => {
        this.setState({
            bidConfirmModal: this.state.bidConfirmModalType == "Auction" ? true : false,
            paymentSelectionModal: this.state.bidConfirmModalType == "BuyNow" ? true : false,
            [type]: false,
        })
    }

    navigateToUrl = (url) => {
        window.open(url, "_blank");
    }

    returnAssuranceModal = (type) => (
        <>
            {
                this.props.user.suspensionstatus != "ALL" && (this.state.showGDModal || this.state.showRAModal) && !this.state.disablePaymentMethod  ?
                    <div className='seel-applet rounded'>
                        <div className='d-flex justify-content-between'>
                            <div className='heading'>Bid with Confidence</div>
                            <span className='text-bold'>Provided By <span style={{ color: "#0202FF" }}>seel</span></span>
                        </div>
                        {
                            this.state.showRAModal ?
                                <div className='d-flex flex-row align-items-center gap-3'>
                                    <img className='mir-icon' src={`${process.env.PUBLIC_URL}/static/icons/common-icons/mir.svg`} alt='make-it-returnable-icon' />
                                    <div className='d-flex flex-grow-1 justify-content-between'>
                                        <div className='d-flex flex-column'>
                                            <div className='d-flex gap-10'>
                                                <span className='text-bold f-16'>Make It Returnable <sup>TM</sup></span>
                                                <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/info.svg`} alt='info-icon' onClick={() => { this.openRAInfoModal(type) }} />
                                            </div>
                                            <div className='d-flex flex-row'>
                                                <span className='text-muted'>For ${this.state.showRAModal ? parseFloat(this.state.seelData?.price.toString()).toFixed(2) : <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img>}, you can add this option to return these item(s) for any reason within 7 days of pickup or shipping.</span>
                                            </div>
                                        </div>
                                        <Form.Check type="switch" id="returnassurance" checked={this.state.isreturnassurance} onChange={this.changeReturnAssurance} />
                                    </div>
                                </div> : ''
                        }
                        {
                            this.state.showGDModal ?
                                <div className='d-flex flex-row align-items-center gap-3'>
                                    <img className='dg-icon' src={`${process.env.PUBLIC_URL}/static/icons/common-icons/dg.svg`} alt='guarateed-delivery-icon' />
                                    <div className='d-flex flex-grow-1 justify-content-between'>
                                        <div className='d-flex flex-column'>
                                            <div className='d-flex gap-10'>
                                                <span className='text-bold f-16'>Delivery Guarantee <sup>TM</sup></span>
                                                <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/info.svg`} alt='info-icon' onClick={() => { this.openDeliveryInfoModal(type) }} />
                                            </div>
                                            <div className='d-flex flex-row'>
                                                {
                                                    this.props.user.membershipCompleted && this.state.ispremierCredit ?
                                                        <div className='d-flex flex-column text-muted'>
                                                            <span>This item is protected against loss, damage & theft as part of your Premier membership.</span>
                                                            <span>*Only available for shipped items.</span>
                                                        </div> :
                                                        <div className='d-flex flex-column text-muted'>
                                                            <span>Protect against loss, damage, theft & offset emissions for ${this.state.showGDModal ? parseFloat(this.state.seelGDData?.price.toString()).toFixed(2) : <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img>}.</span>
                                                            <span>*Only available for shipped items.</span>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                        <Form.Check type="switch" id="deliveryguarantee" checked={this.state.isdeliveryguarantee} disabled={this.state.ispremierCredit} onChange={this.changeDeliveryGuarantee} />
                                    </div>
                                </div> : ''
                        }
                    </div> :
                    this.state.showSeelLoading || this.state.showGDSeelLoading ?
                        <div className='d-flex flex-column rounded align-items-center text-danger' style={{ padding: "10px 20px 10px 20px", backgroundColor: "#F5F4FF" }}>
                            <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img>
                        </div> : ''
            }

            {
                this.state.showSeelErrorMessage || this.state.showGDSeelErrorMessage ?
                    <div className='d-flex flex-column rounded text-center text-danger' style={{ padding: "10px 20px 10px 20px", backgroundColor: "#F5F4FF" }}>
                        {this.state.showSeelErrorMessage ? this.state.showSeelErrorMessage : this.state.showSeelErrorMessage}
                        {this.state.showGDSeelErrorMessage ? this.state.showGDSeelErrorMessage : this.state.showGDSeelErrorMessage}
                    </div> : ''
            }
        </>
    )

    getSeelDetails = (type) => {
        let data = {
            "saleid": this.saleId,
            "itemid": this.itemId,
            "bidprice": type == "buyNow" ? this.state.itemsDetails.buynowprice : this.state.placeBidForm.amount.value,
            "itemreceiptmethod": type == "buyNow" ? this.state.buynowItemReceiptValue : this.state.itemReceiptValue
        }
        this.setState({
            showSeelLoading: true
        })
        axios.post(getBuyersUrl(seelDetailsData), { data: data }, getBuyerHeaders(true, '', '', "seel")).then(
            response => {
                this.setState({
                    showSeelLoading: false,
                    showPayment: true,
                });
                if (response.data.status == "success") {
                    if (typeof response.data?.data == 'object') {
                        if (response.data.data.status == "accepted") {
                            this.setState({
                                seelData: response.data.data,
                                showRAModal: true,
                                isreturnassurance: false
                            })
                        }
                    }
                }
            }
        ).catch((error) => {
            this.setState({
                showPayment: true,
                showSeelLoading: false,
            }, () => {
                if (error.response.data.ctbidserrorcode == "CBRA001") {
                    this.setState({
                        showSeelErrorMessage: "RA insurance not available for this item Please contact CTBIDSHelp for any queries.",
                    })
                }
            });
        })
    }

    getSeelGDDetails = (type) => {
        let data = {
            "saleid": this.saleId,
            "itemid": this.itemId,
            "bidprice": type == "buyNow" ? this.state.itemsDetails.buynowprice : this.state.placeBidForm.amount.value,
            "itemreceiptmethod": type == "buyNow" ? this.state.buynowItemReceiptValue : this.state.itemReceiptValue
        }
        this.setState({
            showGDSeelLoading: true
        })
        axios.post(getBuyersUrl(seelGDDetailsData), { data: data }, getBuyerHeaders(true, '', '', "seel")).then(
            response => {
                this.setState({
                    showGDSeelLoading: false,
                });
                if (response.data.status == "success") {
                    if (typeof response.data?.data == 'object') {
                        if (response.data.data.status == "accepted") {
                            let remainingCredits = response.data.data.credits.remainingcredits;
                            this.setState({
                                seelGDData: response.data.data,
                                showGDModal: true,
                                showPayment: true,
                                isdeliveryguarantee: !this.state.disablePaymentMethod && this.props.user.membershipCompleted && remainingCredits > 0 ? true : false,
                                ispremierCredit: remainingCredits > 0 ? true : false
                            })
                        }
                    }
                }
            }
        ).catch((error) => {
            this.setState({
                showPayment: true,
                showGDSeelLoading: false,
            }, () => {
                if (error.response.data.ctbidserrorcode == "CBRA001") {
                    this.setState({
                        showGDSeelErrorMessage: "RA insurance not available for this item Please contact CTBIDSHelp for any queries.",
                    })
                }
            });
        })
    }

    getPlaceBidSeelData = (type) => {
        if (type == "buynow") {
            this.getSeelDetails("buyNow");
            if (this.state.itemReceiptValue == "shipping" || this.state.buynowItemReceiptValue == "shipping") {
                this.getSeelGDDetails("buyNow");
            }
        } else {
            if (!(parseFloat(this.state.placeBidForm.amount.value) < parseFloat(this.state.currentBid + this.state.incrementvalue))) {
                this.getSeelDetails();
                if (this.state.itemReceiptValue == "shipping" || this.state.buynowItemReceiptValue == "shipping") {
                    this.getSeelGDDetails();
                }
            }
        }
    }

    getIrmDetails = () => {
        axios.get(getBuyersUrl(`${irmDetails}${this.saleId}/${this.itemId}`), getBuyerHeaders()).then(
            response => {
                this.setState({
                    irmSelected: response.data.data,
                    bidderIRMChecked: response.data?.data[0]?.itemreceiptmethod,
                })
            }
        ).catch((error) => {
        })
    }

    getEligibleCategoryandLocation = () => {
        let data = { "contentkey": ["rav2", "gdv2"] }
        axios.post(getSellerUrl(eligibleCategoryandLocation), { data: data }).then(
            response => {
                this.setState({
                    raEligibleList: response.data.data.rav2,
                    dgEligibleList: response.data.data.gdv2
                })
            }
        )
    }

    renderEligibilities = () => (
        <div className='eligibilities-container'>
            <div className='eligibilities'>
                {
                    this.state.itemsDetails.isshippable === 0 ?
                        <>
                            <div>
                                <img src={`${process.env.PUBLIC_URL}/static/images/Common/pickup.svg`} alt="shippable"></img>
                            </div>
                            <div className='d-flex flex-column'>
                                <div className='label'>This item is pick-up only in</div>
                                <div className="address">{titleCase(this.state.itemsDetails.city)}, {this.state.itemsDetails.state}</div>
                            </div>
                        </> :
                        <>
                            <div>
                                <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/shippable-truck.svg`} alt="shippable"></img>
                            </div>
                            <div className='d-flex flex-column'>
                                <div className='label'>This item is shippable</div>
                                <div className="address">{titleCase(this.state.itemsDetails.city)}, {this.state.itemsDetails.state}</div>
                            </div>
                        </>
                }
            </div>

            {
                (this.state.itemIrm.includes("shipping") || this.state.itemIrm.includes("pickup")) &&
                    this.state.raEligibleList?.raeligiblelocation && this.state.raEligibleList["raeligiblelocation"]?.includes(this.state.itemsDetails?.locationid) &&
                    this.state.raEligibleList["raeligiblecategory"][this.state.itemsDetails?.categoryGroup]?.includes(this.state.itemsDetails.category) &&
                    (this.state.itemsDetails.itemtypeid == 1 ? this.state.itemsDetails.buynowprice : this.state.currentBid) >= this.state.raEligibleList["rapricerange"]?.minamount &&
                    (this.state.itemsDetails.itemtypeid == 1 ? this.state.itemsDetails.buynowprice : this.state.currentBid) <= this.state.raEligibleList["rapricerange"]?.maxamount ?
                    <div className='eligibilities'>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/mir.svg`} alt="MIR" />
                        <span className='label'>Make It Returnable Eligible</span>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement={'top'}
                            overlay={
                                <Popover id={`popover-positioned`}>
                                    <Popover.Body>Bid price between $15 to $1000 is eligible.</Popover.Body>
                                </Popover>
                            } className="custom-overlay-trigger">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/info.svg`} alt='info-icon' />
                        </OverlayTrigger>
                    </div> : null
            }

            {
                this.state.itemIrm.includes("shipping") &&
                    this.state.dgEligibleList.gdeligiblelocation && this.state.dgEligibleList["gdeligiblelocation"]?.includes(this.state.itemsDetails?.locationid) &&
                    this.state.dgEligibleList["gdeligiblecategory"][this.state.itemsDetails?.categoryGroup]?.includes(this.state.itemsDetails.category) &&
                    (this.state.itemsDetails.itemtypeid == 1 ? this.state.itemsDetails.buynowprice : this.state.currentBid) >= this.state.dgEligibleList["gdpricerange"]?.minamount &&
                    (this.state.itemsDetails.itemtypeid == 1 ? this.state.itemsDetails.buynowprice : this.state.currentBid) <= this.state.dgEligibleList["gdpricerange"]?.maxamount ?
                    <div className='eligibilities'>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/dg.svg`} alt="DG" />
                        <span className='label'>Delivery Guarantee Eligible</span>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement={'top'}
                            overlay={
                                <Popover id={`popover-positioned`}>
                                    <Popover.Body>Bid price between $15 to $1000 is eligible.</Popover.Body>
                                </Popover>
                            } className="custom-overlay-trigger">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/info.svg`} alt='info-icon' />
                        </OverlayTrigger>
                    </div> : null
            }
        </div>
    );

    renderItemDetails = () => (
        <div className="item-detail-container">
            <div className="header">Item Details</div>

            <div className="item-detail">
                <div className="left-side">Location</div>
                <div className="right-side" style={{ wordBreak: "break-all" }}>{this.state.itemsDetails.locationtitle}</div>
            </div>

            <div className="item-detail">
                <div className="left-side">Item SKU</div>
                <div className="right-side" style={{ wordBreak: "break-all" }} >{this.state.itemsDetails.SKU}</div>
            </div>

            <div className="item-detail">
                <div className="left-side">Purchase Type</div>
                <div className="right-side" style={{ wordBreak: "break-all" }} >
                    {this.state.itemsDetails.itemtypename}
                    <span style={{ color: "#2499FF", fontSize: "14px" }}>{this.state.itemsDetails.itemtypename === "Auction" && this.state.itemsDetails.reserveprice > 0 ? " With Reserve" : ""}</span>
                </div>
            </div>

            <div className="item-detail">
                <div className="left-side">Item Views</div>
                <div className="right-side" style={{ wordBreak: "break-all" }} >{this.state.itemsDetails.itemviewcount}</div>
            </div>

            <div className="item-detail">
                <div className="left-side">Buyer's Premium</div>
                <div className="right-side" style={{ wordBreak: "break-all" }} >{this.state.itemsDetails.buyerspremium}</div>
            </div>

            {this.state.itemsDetails.itemstatus !== "Pending"  && <div className="item-detail">
                <div className="left-side">Item Closes</div>
                <div className="right-side" style={{ wordBreak: "break-all" }} >  {
                    this.state.itemsDetails.itemstatus === "Ready" ? <>{this.getCloseinDatetime(this.state.itemsDetails.itemclosetime)}</> :
                        <div className='text-danger'>
                            {this.state.itemsDetails.itemstatus === "Sold" || this.state.itemsDetails.itemstatus === "Not Sold" ? 'Item closed' : ''}
                        </div>
                }</div>
            </div>}

            <div className="item-detail">
                <div className="left-side">Dimensions</div>
                <div className="right-side">Width {this.state.itemsDetails.width || 0} / Height {this.state.itemsDetails.height || 0} / Length {this.state.itemsDetails.length || 0} (inches)</div>
            </div>

            {
                this.state.itemsDetails.weight ?
                    <div className="item-detail">
                        <div className="left-side">Weight</div>
                        <div className="right-side">{this.state.itemsDetails.weight} (lbs)</div>
                    </div> : null
            }
        </div>
    );


    renderMoreDetails = () => {
        return(

        <div className="more-details-section">
            <div className="header">More Details</div>
            <Accordion alwaysOpen>
                <Accordion.Item eventKey="0">
                    <Accordion.Header as="div" className='more-detail-title'>Pickup Details</Accordion.Header>
                    <Accordion.Body>
                    {this.htmlTextConverter(this.state.itemsDetails.pickupinfo, 'pickup')}
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header as="div"  className='more-detail-title'>
                        Comments
                        {
                            isAuthorized() && this.state.suspendList.length === 0 ?
                                <div className={`ask-a-question-button`} onClick={this.askAQuestionModal}>Ask Seller a Question</div>
                                : null
                        }
                    </Accordion.Header>
                    <Accordion.Body>
                        {
                            this.state.messageList.map((message, index) =>
                                <div className="shipping d-flex flex-column" key={`messgae_${index}`}>
                                    <div className="d-flex mb-3  flex-column">
                                        <div className="left-side remove-weight w-100 message-l pr-2">
                                            {message.createdby}
                                        </div>
                                        <div className="right-side message-r w-100">
                                            {message.message}
                                        </div>
                                    </div>
                                    {
                                        message.reply.length > 0 ?
                                            <div className="d-flex flex-column mt2 mb-3">
                                                <div className="left-side remove-weight message-l pr-2">
                                                    Seller
                                                </div>
                                                <div className="right-side message-r">
                                                    {
                                                        message.reply.map((reply, subIndex) =>
                                                            <div key={subIndex}>{reply.reply}</div>
                                                        )
                                                    }
                                                </div>
                                            </div> : null
                                    }
                                </div>
                            )
                        }
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header as="div"  className='more-detail-title'>Shipping Information</Accordion.Header>
                    <Accordion.Body>
                    {/* <div className='message-wrap' dangerouslySetInnerHTML={{ __html: this.state.itemsDetails.shippinginfo }}></div> */}
                    {this.htmlTextConverter(this.state.itemsDetails.shippinginfo, 'shipping')}
                    </Accordion.Body>                    
                </Accordion.Item>
               
                <Accordion.Item eventKey="3">
                    <Accordion.Header  as="div" className='more-detail-title'>Payment Instructions</Accordion.Header>
                    <Accordion.Body>
                    {this.htmlTextConverter(this.state.itemsDetails.paymentinfo, 'payment')}
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                    <Accordion.Header as="div"  className='more-detail-title'>Terms and Conditions</Accordion.Header>
                    <Accordion.Body>
                    {this.htmlTextConverter(this.state.itemsDetails.termsandconditions, 'terms')}

                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
        );
    }
    
    navigateToCategoryGroup = (categoryGroup) => {
        let pusttoStore = { ...this.props.statemaintenance };
        pusttoStore['Category'] = {
            filtervalue: { categoryGroup }
        }
        store.dispatch({
            type: 'PUSH_TO_STATE',
            payload: pusttoStore
        });
        resetBreadcrumbs();
        const routePath = `/category/${categoryGroup}`;
        navigateUsingBreadcrumbs(this.props.history, routePath, "/category");
    };

    navigateToCategory = (category) => {
        let pusttoStore = { ...this.props.statemaintenance };
        pusttoStore['Category'] = {
            filtervalue: { categoryGroup: this.state.itemsDetails.categoryGroup, category: category }
        }
        store.dispatch({
            type: 'PUSH_TO_STATE',
            payload: pusttoStore
        });
        resetBreadcrumbs();
        const routePath = `/category/${this.state.itemsDetails.categoryGroup}/${category}`;
        navigateUsingBreadcrumbs(this.props.history, routePath, "/category");
    };

    render() {
        return (
            <div className="item-view-main" ref={this.itemViewRef} onScroll={this.handleScroll}>
                <Helmet>
                    <title>{this.itemTitle ? this.itemTitle : this.state.itemsDetails.title}</title>
                    <meta name='description' content={this.state.itemsDetails.category + ' ' + this.state.itemsDetails.tag} />
                    <link rel="canonical" href={`${this.state?.prevPath ? `https://ctbids.com${this.state?.prevPath}` : this.props?.location?.pathname ? `https://ctbids.com${this.props.location.pathname}` : 'https://ctbids.com'}`} />
                </Helmet>
                <h1 className='d-none'>{`${this.state.itemsDetails.title ? this.state.itemsDetails.title : '' } | CTBids`}</h1>
                <h2 className='d-none'>{`Bid Now on This Unique Collection of ${this.state.itemsDetails.category}`}</h2>
                {
                    this.state.pageLoading && !this.state.noDataFound ?
                        <Loader /> :
                        <>
                            {/** Breadcrumbs section */}
                            <div className='d-flex'>

                            <Breadcrumbs
                                props={this.props}
                                type={BREADCRUMB_TYPE_CONFIG.ITEM_VIEW}
                                options={{ saleId: this.saleId, itemId: this.itemId, saleTitle: this.state.itemsDetails.saletitle, itemTitle: this.state.itemsDetails.title, itemSeoUrl: this.itemTitle || this.state.itemsDetails.itemseourl || this.state.itemsDetails.title }}
                                mobileBack={true} />

                            <div className='d-flex align-items-center flex-end justify-content-between ms-auto' style={{marginRight: '20px'}}>

                                {/** Previous and next section */}
                                {
                                    this.previousItemId || this.nextItemId ?
                                        <div className='previous-next-section d-flex gap-2'>
                                            {
                                                this.previousItemId &&
                                                <Button variant='outline' className='btn btn-white d-flex align-items-center justify-content-center gap-2' onClick={() => this.onPreviousNextClick(true)}>
                                                    {LeftArrowLineDimmed} Previous
                                                </Button>
                                            }
                                            {
                                                this.nextItemId &&
                                                <Button variant='outline' className='btn btn-white d-flex align-items-center justify-content-center gap-2' onClick={() => this.onPreviousNextClick(false)}>
                                                    Next {RightArrowLineDimmed}
                                                </Button>
                                            }
                                        </div> : null
                                }
                            </div>
                            </div>
                        <div className="items-view">              

                            {
                                this.state.isVisible ?
                                    <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={() => this.scrollToItemView('Up')}>
                                        <i className="fas fa-arrow-up"></i>
                                    </div> : null
                            }

                            {/* large-screen-width  */}
                            <div className="item-view-container">

                                {/** Left side section */}
                                <div className="item-view-left">

                                    {/** Media section */}
                                    <ItemGalleryHOC list={this.state.itemImageList} onChangeMedia={(index) => { this.setState({ activeMediaIndex: index }); }} />

                                    <div role='button' className={`enlarge-media ${this.state.noImage ? 'd-none' : 'd-flex'}`} onClick={() => { this.setState({ galleryModal: true }); }}>
                                        Click here to enlarge <span style={{marginLeft: '7px'}}>  {enlargeIcon} </span>
                                    </div>

                                    <div className='large-screen-section'>
                                        {/** Eligibilities section */}
                                        {this.renderEligibilities()}

                                        {/** Item details section */}
                                        {this.renderItemDetails()}

                                        {/** More details section */}
                                        {this.renderMoreDetails()}
                                    </div>
                                </div>

                                {/** Right side section */}
                                <div className='item-view-right'>

                                    {/** Item category section */}
                                    <div className='category'>
                                        <div onClick={() => { this.navigateToCategoryGroup(this.state.itemsDetails.categoryGroup)} } className='category-group-tag'>
                                            {this.state.itemsDetails.categoryGroup}
                                        </div>
                                        <div onClick={() => this.navigateToCategory(this.state.itemsDetails.category)} className='category-tag'>
                                            {this.state.itemsDetails.category}
                                        </div>
                                    </div>

                                    {/** Item title */}
                                    <div className='title'>{this.state.itemsDetails.title}</div>

                                    {
                                        this.state.itemsDetails.itemstatus === 'Ready' && !this.state.isItemClosed ?
                                            <div className='d-flex align-items-center justify-content-between justify-content-sm-start gap-3'>
                                                <div className='text-dark font-weight-bold' style={{ fontSize: '16px' }}>Item closes in</div>
                                                {
                                                    this.state.currentBidLoading ? 
                                                    <img className="loader-gif" src={loaderIcon} alt="loader" />:
                                                    <CountdownHoc itemId={this.itemId} targetTime={this.state.itemsDetails.itemclosetime} type={COUNTDOWN_TYPE.ITEM} showFullLabel={true} onMinCallback={(minsAvailable) => {
                                                        this.setState({ duration: minsAvailable });
                                                    }}/>
                                                }
                                            </div> :
                                            <div className='text-danger'>
                                                {
                                                    this.state.itemsDetails.itemstatus === "Sold" || this.state.itemsDetails.itemstatus === "Not Sold" || this.state.isItemClosed ? 'Item closed' : 'Item not available'
                                                }
                                            </div>
                                    }

                                    {/** Item bid section */}
                                    <div className='bid'>
                                        {
                                            this.state.itemsDetails.itemtypeid === 2 ?
                                                <>
                                                    <div className="current-bid">Current Bid</div>
                                                    {
                                                        this.state.currentBidLoading ? 
                                                        <img className="loader-gif" src={loaderIcon} alt="loader" /> : 
                                                        <div className="current-bid-value-container">
                                                            <div className='current-bid-value'>${parseFloat(this.state.currentBid).toFixed(2)}</div>
                                                            <div className='d-flex gap-2 flex-wrap'>
                                                                {
                                                                    this.state.itemsDetails.reserveprice ?
                                                                        this.state.currentBid >= this.state.itemsDetails.reserveprice ? 
                                                                        <span className='text-buy-now-color'>Reserve Price Met</span> : 
                                                                        <span className='text-danger'>Reserve Price Not Met</span> : 
                                                                    null
                                                                }

                                                                <div>{this.state.bidHistory.length || this.state.bidCount} Bid(s)</div>

                                                                {
                                                                    this.props.user.id ?
                                                                    <span role='button' className="bid-count" onClick={this.bidHistoryModalToggle}>View Bid History</span> :
                                                                    <span role='button' className='view-bid-history' onClick={this.signIn}>Sign in to view bid history</span>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </> : null

                                        }


                                        <div className='bid-info-section'>

                                            <div className={`item-values-section ${this.state.itemsDetails.itemtypeid !== 2 ? 'remove-border' : ''}`}>
                                                {
                                                    this.state.itemsDetails.itemtypeid === 2 ?
                                                        <div className='d-flex gap-4'>
                                                            <div className="bid-values-container">
                                                                <div className='label'>Minimum</div>
                                                                <div className="amount">${parseFloat(this.state.currentBid + this.state.incrementvalue).toFixed(2)}</div>
                                                            </div>
                                                            <div className="bid-values-container">
                                                                <div className='label'>Increment</div>
                                                                <div className="amount">${parseFloat(this.state.incrementvalue).toFixed(2)}</div>
                                                            </div>
                                                        </div> : null
                                                }
                                                { this.state.itemsDetails.buynowprice > 0 && <div className='d-flex align-items-center gap-2'>
                                                    <div className="bid-values-container">
                                                        <div className='label'>Buy Now Price</div>
                                                        <div className="amount">${this.state.itemsDetails.buynowprice ? parseFloat(this.state.itemsDetails.buynowprice).toFixed(2) : '0.00'}</div>
                                                    </div>
                                                    {
                                                        this.state.itemsDetails.salestatus === "Started" &&
                                                        this.state.itemsDetails.itemstatus === "Ready" &&
                                                        !this.state.isItemClosed &&
                                                        this.state.itemsDetails.buynowprice > 0 &&
                                                        !this.state.removeBuyNow &&
                                                        this.props.user.profilecompleted === 1 &&
                                                        this.state.duration > 5 ?
                                                        <Button className='buy-now' variant='outline-green' disabled={!this.props.user.active} onClick={this.buyNow}>Buy Now</Button> : null
                                                    }
                                                </div>}
                                                {
                                                    this.state.itemsDetails.itemtypeid === 2 && isAuthorized() && this.state.bidHistoryData?.myproxyprice ?
                                                        <div className="bid-values-container">
                                                            <div className="label">My Proxy Bid</div>
                                                            <div className="amount">${parseFloat(this.state.bidHistoryData.myproxyprice).toFixed(2)}</div>
                                                        </div> : null
                                                }
                                                {
                                                    this.props.user.id && this.state.itemsDetails.itemtypeid === 2 ?
                                                        <div className="bid-values-container">
                                                            <div className='label'>Highest Bidder</div>
                                                            <div className="amount">{this.state.highestBidder}</div>
                                                        </div> : null
                                                }
                                            </div>

                                            <div>
                                                <Button type="button" size="sm" ref={(buttonDOM) => { this[`buttonDOM`] = buttonDOM; }}
                                                    className={`wishlist-btn ${this.watching() ? 'watching-active' : ''} d-flex align-items-center`}
                                                    onClick={(event) => { this.watch(event) }}
                                                    disabled={!isAuthorized() || this.state.itemsDetails.itemstatus !== "Ready" || this.state.isItemClosed}>
                                                    {eye}{"Add to Watchlist"}
                                                </Button>
                                            </div>

                                            <div className='d-flex flex-column gap-2'>
                                                {
                                                    this.state.itemsDetails.itemtypeid === 2 ?
                                                        <div className="bid-input-section">
                                                            <FormControl
                                                                size="lg"
                                                                placeholder="$ Enter Amount"
                                                                aria-label="Bid"
                                                                className="bid-input"
                                                                name="amount"
                                                                type="text"
                                                                value={this.state.placeBidForm.amount.value}
                                                                onChange={(event) => this.onInputValidation(event, 'placeBidForm', 2)}
                                                                disabled={!this.props.user.id || this.state.itemsDetails.itemstatus !== "Ready" || this.state.itemsDetails.itemclosetime == null || this.state.isItemClosed} />
                                                            {
                                                                isAuthorized() ?
                                                                    <Button className="btn-secondary"
                                                                        disabled={(!this.state.formValid || this.props.user.profilecompleted === 0 || this.state.itemsDetails.itemstatus !== "Ready" || this.state.isItemClosed || this.props.user.paymentcompleted === 0) || this.state.placebidLoading || this.state.placeBidForm.amount.value <= 0}
                                                                        onClick={this.placeBidConfirmModal}
                                                                        style={{ borderRadius: "5px", width: "50%", padding: "0.7rem", fontSize: "14px" }}>
                                                                        Place Bid {this.state.placebidLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                                    </Button> :
                                                                    <Button className="btn-secondary" onClick={this.signIn} style={{ borderRadius: "5px", width: "100%", padding: "0.7rem" }}>Sign in to place Bid</Button>
                                                            }
                                                        </div> : null

                                                }

                                                {
                                                    isAuthorized() && this.props.user.profilecompleted === 0 ?
                                                        <div>
                                                            <small className="text-danger text-danger-font">Complete Profile to bid. <span className="external-link" onClick={this.profileComplete}>Click here to update.</span></small>
                                                        </div> :
                                                        isAuthorized() && this.props.user.paymentcompleted === 0 ?
                                                            <div>
                                                                <small className="text-danger text-danger-font">Complete Payment Method to bid. <span className="external-link" onClick={() => { this.paymentComplete() }}>Click here to update.</span></small>
                                                            </div> : null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {/** Item description section */}
                                    <div className='mt-4 pt-3 border-top'>
                                        <div className='heading mb-3'>Item Description</div>
                                        {this.state.itemsDetails.description ? this.htmlTextConverter(this.state.itemsDetails.description ) : `- - -`}
                                    </div>

                                    <div className='small-screen-section'>
                                        {/** Eligibilities section */}
                                        {this.renderEligibilities()}

                                        {/** Item details section */}
                                        {this.renderItemDetails()}

                                        {/** More details section */}
                                        {this.renderMoreDetails()}
                                    </div>

                                    {/** About this seller section */}
                                    <div className='about-seller mt-4 pt-3 border-top'>
                                        <div className="heading">About this Seller</div>
                                        <div className='d-flex pt-3 gap-4'>
                                            <div className="image-container d-flex align-items-center justify-content-center">
                                                {
                                                    this.state.locationImage.filter(x => x.name === 'profile').length === 0 ?
                                                        <img src={image_thumbnail} alt="default-thumbnail" /> :
                                                        this.state.locationImage.filter(x => x.name === 'profile').map((x, index) =>
                                                            <img src={x.url} alt="about-seller" key={`seller_${index}`} />
                                                        )
                                                }
                                            </div>
                                            <div className="d-flex flex-column gap-3">
                                                <div className="location-title"><b>{this.state.itemsDetails.locationtitle}</b></div>
                                                <div className="location-address">{this.state.itemsDetails.locationstate}</div>
                                                <div className='d-flex flex-column gap-2'>
                                                    {
                                                        isAuthorized() && this.state.suspendList.length === 0 ?
                                                            <Button variant='secondary' onClick={this.askAQuestionModal}>Ask Seller a Question</Button> : null
                                                    }
                                                    <Button variant='outline-grey text-start' className='text-black' onClick={this.moreSale}>More Sales from this Location</Button>
                                                    <Button variant='outline-grey text-start' className='text-black' onClick={() => { this.estateSale() }}>More Items from this Estate Sale</Button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="about-discription">
                                            {this.state.itemsDetails.about}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex flex-column align-items-center justify-content-center mt-5 mb-5'>
                                {
                                    Array.isArray(this.state.configData.list) && this.state.configData.list.length > 0 ? 
                                    <PaginationListHOC
                                        config={{ ...this.state.configData, title: "View more products from this Estate Sale", }}
                                        emptyCont={""}
                                    /> : null
                                }
                                <Button
                                    className='btn-white  rounded text-bold d-flex align-items-center gap-5'
                                    onClick={() => { this.estateSale() }}
                                ><div>Show more items from this estate sale</div>     <div > {RightArrowLine}</div></Button>
                            </div>
                        </div>
                        </>
                }

                <Modal centered show={this.state.buyNowConfirmModal} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="bid-confirmation">
                            <div className="header">
                                Confirmation
                            </div>
                            {
                                this.state.buyNowModalHandle.loading ?
                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                        <Spinner as="div" animation="border" size="lg" variant="info" className="mx-2"></Spinner>
                                        <div>Please wait...</div>
                                    </div> :
                                    this.state.buyNowModalHandle.message ? <div className="api-error mt-3">
                                        {this.state.buyNowModalHandle.message}
                                    </div> :
                                        <div className="body-content">
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Buy Now Price</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.buynowprice}</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Tax</div>
                                                <div className="price">{this.state.itemsDetails.istaxable ? this.state.itemsDetails.tax : 0}%</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Tax Amount</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.taxValue}</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Buyer's Premium</div>
                                                <div className="price">{this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0}%</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Buyer's Premium Amount</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.buyerspremium}</div>
                                            </div>
                                            {
                                                this.state.totalPriceForBuyNow.applytaxonbp === 1 ?
                                                    <div className="d-flex align-items-ccenter justify-content-between">
                                                        <div className="text-muted">Tax On BP Amount</div>
                                                        <div className="price">${this.state.totalPriceForBuyNow.taxonbpamount}</div>
                                                    </div> : null
                                            }
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Shipping Fee Amount</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.shippingfee}</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Handling Fee Amount</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.handlingfee}</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Total</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.total}</div>
                                            </div>
                                        </div>
                            }
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2 modal-button" onClick={() => this.closeConfirmModal()}>Cancel</Button>
                            <Button variant="secondary" onClick={() => this.confirmPaymentSelection()} disabled={this.state.totalPriceForBuyNow.total < 1 || this.state.buynowLoading}>Confirm {this.state.buynowLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.itemReciptModel || this.state.shippingModel || this.state.bidConfirmModal} size='lg' animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className='bid-confirmation'>
                            {
                                parseFloat(this.state.placeBidForm.amount.value) < parseFloat(this.state.currentBid + this.state.incrementvalue) ?
                                    <>
                                        <div className='d-flex minimum-amount-section gap-3'>
                                            <img role='button' src={`${process.env.PUBLIC_URL}/static/icons/common-icons/close.svg`} onClick={() => this.closeConfirmModal()} />
                                            <div className='header'>Minimum amount not met</div>
                                        </div>
                                        <div className='mt-3 mb-3'>Your bid doesn't meets the minimum amount needed for this item. Please check the details below and change the bid amount accordingly</div>
                                        <div className='bid-values-wrapper'>
                                            <div className='bid-values-container'>
                                                <div >Minimum bid amount</div>
                                                <div className='bid-values'>${parseFloat(this.state.currentBid + this.state.incrementvalue).toFixed(2)}</div>
                                            </div>
                                            <div className='bid-values-container'>
                                                <div>Buyer's Premium</div>
                                                <div className='bid-values'>{this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0}%</div>
                                            </div>
                                            <div className='bid-values-container'>
                                                <div>Buyer's Premium Amount</div>
                                                <div className='bid-values'>${this.state.placeBidValue.buyerspremiumValue}</div>
                                            </div>
                                        </div>
                                    </> :
                                    <>
                                        <div className='d-flex confirm-your-bid gap-3'>
                                            <img role='button' src={`${process.env.PUBLIC_URL}/static/icons/common-icons/close.svg`} onClick={() => this.closeConfirmModal()} />
                                            <div className='header'>Confirm your Bid details</div>
                                            {this.state.itemIrm.length === 0 || !this.state.bidderCheck && <div className='ms-auto'>{this.state.steps}/{this.state.itemReceiptValue == 'pickup' ? '2' : '3'}</div>}
                                        </div>
                                        {
                                            this.state.itemReciptModel ?
                                                <>
                                                    {
                                                        this.state.irmOptionData[0] === 'pickup' && this.state.irmOptionData.length === 1 ?
                                                            <>
                                                                <div className="text-center text-secondary font-weight-bold ">
                                                                    You've Selected Pickup!
                                                                </div>

                                                                <div className="text-center text-bold " style={{ padding: '10px 20px 10px 20px' }}>
                                                                    This is a pickup only item. By selecting Confirm, you acknowledge you are responsible for receiving this item.
                                                                </div>
                                                            </> :
                                                            <>
                                                                <div className='mt-3 mb-3'>Please confirm how you would like to obtain your product on bid success:</div>
                                                                <Form.Group className="d-flex flex-column gap-3">
                                                                    {
                                                                        this.state.irmOptionData.map((value, index) =>
                                                                            value && <Form.Check custom type="radio" id={value} name="invoiceItemReceipt" label={this.captializeLetter(value)} value={value ? value : ''} onChange={(event) => this.onChangeOption(event)} />
                                                                        )
                                                                    }
                                                                </Form.Group>
                                                            </>
                                                    }
                                                </> : null
                                        }

                                        {
                                            this.state.shippingModel ?
                                                <>
                                                    <div className='mt-3'>Please confirm your {this.state.itemReceiptValue} address. If you want to add a new {this.state.itemReceiptValue} address, go to your Account Settings {`>>`} My Personal Info {`>>`} Add new address</div>
                                                    <div className="m-4">{this.state.shippingto.address + this.state.shippingto.cityState + this.state.shippingto.countryZipcode}</div>
                                                </> : null
                                        }

                                        {
                                            this.state.bidConfirmModal ?
                                                <>
                                                    <div className='mt-3 mb-3'>Please find below the details of the pricing and payment structure</div>
                                                    <div className='bid-values-wrapper mb-3'>
                                                        <div className="bid-values-container">
                                                            <div>Your Maximum Bid</div>
                                                            <div className="bid-values">${parseFloat(this.state.placeBidValue.currentValue).toFixed(2)}</div>
                                                        </div>
                                                        <div className="bid-values-container">
                                                            <div>Buyer's Premium</div>
                                                            <div className="bid-values">{this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0}%</div>
                                                        </div>
                                                        <div className="bid-values-container">
                                                            <div>Buyer's Premium Amount</div>
                                                            <div className="bid-values">${parseFloat(this.state.placeBidValue.buyerspremiumValue).toFixed(2)}</div>
                                                        </div>
                                                    </div>
                                                    {
                                                        CATERGORY.includes(this.state.itemsDetails.category) ?
                                                            <div className="placebid-bg">
                                                                <p>
                                                                    By placing a bid on this item, you accept the <span className="term-color clickable" onClick={this.showTermsAndCondition}>Terms and Conditions. </span>
                                                                    This is a speciality purchase, payment must be handled directly with the seller. Upon win, Seller to reach out to secure payment.
                                                                </p>
                                                            </div> :
                                                            this.state.placeBidForm.amount.value > BID_AMOUNT ?
                                                                <div className="placebid-bg">
                                                                    <p>
                                                                        By placing bid on this item, you accept the <span className="term-color clickable" onClick={this.showTermsAndCondition}>Terms and conditions. </span>
                                                                        Any invoice greater than $5,000 will have a 10% deposit automatically processed at time of win.
                                                                        Seller to secure remaining payment.
                                                                    </p>
                                                                </div> : ''
                                                    }

                                                    {
                                                        this.state.bidError ?
                                                            <div className="api-error">
                                                                {this.state.bidError}
                                                            </div> : null
                                                    }

                                                    {this.returnAssuranceModal("Auction")}

                                                </> : null
                                        }

                                        <div className="d-flex align-items-center justify-content-end gap-3 py-2">
                                            <Button variant="outline-dark btn-white" onClick={() => this.closeConfirmModal()}>Cancel bid</Button>

                                            {
                                                this.state.bidConfirmModal ?
                                                    <Button variant="secondary" onClick={() => this.confirmPlaceBid()} disabled={this.state.bidLoading || parseFloat(this.state.placeBidForm.amount.value) < parseFloat(this.state.currentBid + this.state.incrementvalue)}>
                                                        Yes, Confirm My Bid {' '} {this.state.bidLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                    </Button> :
                                                    <Button variant="secondary" disabled={this.state.itemReciptModel ? this.state.itemReceiptValue === "" : false} onClick={() => {
                                                        if (this.state.itemReciptModel) {
                                                            this.confirmIrmMethod();
                                                        } else if (this.state.shippingModel) {
                                                            this.confirmShippingMethod();
                                                        }
                                                    }} >
                                                        Next Step
                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/arrow-right.svg`} alt='arrow-right' />
                                                    </Button>
                                            }
                                        </div>
                                    </>
                            }
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.askAQuestion} animation={false} size="lg" backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="ask-a-question">
                            <div className="header">
                                Ask Seller a Question
                            </div>
                            <div className="info">
                                This will send an email to the seller and also be posted on the item page for others to view, so please avoid using personal information.
                                You can choose to hide the message from the public by checking the "Hide from public" check-box below.
                            </div>
                            <div className="email-address d-flex align-items-center justify-content-between">
                                <div className="email">To: <span>{this.state.itemsDetails.contactemail}</span> </div>
                                <div className="email">From: <span>{this.props.user.lastName}, {this.props.user.firstName}</span></div>
                            </div>
                            <div className="subject">
                                Subject: Question regarding listing with title {this.state.itemsDetails.title}
                            </div>
                            <div>Message</div>
                            <div className="message-box">
                                <textarea className="form-control" name="message" onChange={event => this.onInputValidation(event, 'messageForm', null, 'messageFormValid')}></textarea>
                                {
                                    this.state.messageForm.message.error ? <small className="text-danger mt-10">{this.state.messageForm.message.error}</small> : null
                                }
                            </div>
                            <div className="public">
                                <Form.Check
                                    custom
                                    type="checkbox"
                                    id={`hide`}
                                    label="Hide from public"
                                    name="isPublic"
                                    onChange={event => this.onInputValidation(event, 'messageForm', null, 'messageFormValid', true)}
                                />
                            </div>
                        </div>
                        <div className='d-flex justify-content-center text-center text-danger'>{this.state.suspendedErrorMessage ? this.state.suspendedErrorMessage : ''}</div>
                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2 modal-button" onClick={() => this.closeConfirmModal()}>Cancel</Button>
                            {
                                this.state.messageLoading ?
                                    <Button variant="secondary mx-2 modal-button" disabled>
                                        Send {' '} <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner>
                                    </Button> :
                                    <Button variant="secondary mx-2 modal-button" disabled={!this.state.messageFormValid} onClick={() => this.sendMessage()}>Send</Button>
                            }
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.bidHistoryModal} animation={false} size="lg" onHide={this.bidHistoryModalToggle}>

                    <Modal.Body className="d-flex flex-column">
                    <div className='d-flex justify-content-between align-items-center pb-3'>
                            <h4 className='mb-0'>
                                Bid History
                            </h4>
                            <div className='d-flex align-items-center'>
                                <img
                                    role='button'
                                    src={`${process.env.PUBLIC_URL}/static/icons/common-icons/close.svg`}
                                    onClick={() => this.bidHistoryModalToggle()}
                                    style={{ height: '25px', width: '25px', objectFit: 'contain' }}
                                />
                            </div>
                        </div>

                        <div className="w-100 modal-table table-bid-history">
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Bidders</th>
                                        <th>Bid Date</th>
                                        <th>Bid Time</th>
                                        <th>Bid Amount</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.bidHistory.length === 0 ?
                                            <tr>
                                                <td colSpan="5" className="text-center">No Data Found</td>
                                            </tr> :
                                            this.state.bidHistory.map((bidding, index) =>
                                                <tr key={`bid_history_${index}`}>
                                                    <td>{bidding.nickname}</td>
                                                    <td>{dateTimeFormat(bidding.createddate)}</td>
                                                    <td>{dateTimeFormat(bidding.createddate, true)}</td>
                                                    <td>${bidding.bidprice ? parseFloat(bidding.bidprice).toFixed(2) : '' }</td>
                                                    <td>{index === 0 ? 'Current Bid' : 'Out Bid'}</td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal
                    ref={this.galleryModalRef}
                    show={this.state.galleryModal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="gallery-modal"
                >
                    <Modal.Body>
                        <div className='gallery-modal-container'>
                            <div className='d-flex justify-content-between'>
                                <h3 className='title'>{this.state.itemsDetails.title}</h3>
                                <img role='button' src={`${process.env.PUBLIC_URL}/static/icons/common-icons/close.svg`} onClick={() => { this.setState({ galleryModal: false }); }} />
                            </div>
                            <ItemGalleryHOC list={this.state.itemImageList} galleryInModal={true} modalRef={this.galleryModalRef} activeIndex={this.state.activeMediaIndex} />
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered
                    animation={false}
                    backdrop="static"
                    enforceFocus={false}
                    show={!this.props.sessionModal && this.state.refreshData?.showModal}
                >
                    <Modal.Body >
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Oops, something went wrong... {isAuthorized() ? <p>Try to refresh the page, or log out and log in again.</p> : <p>Try to refresh the page.</p>}
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" onClick={this.onCloseSomethingWentWrongModal}>Cancel</Button>
                                <Button variant="secondary mx-2" onClick={this.onRefreshSomethingWentWrongModal}>Refresh</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered className="terms-dialog" id="terms-and-condition" show={this.state.estateTermsConditions} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Header centered>
                        <div className="header">Terms &amp; Conditions</div>
                        <div className="terms-close-icon close-icon-1 clickable" onClick={this.handleCloseTerms}>&times;</div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='message-wrap' dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(this.state.itemsDetails.termsandconditions) }}></div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.paymentSelectionModal} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="payment-close-icon">
                            <div className="close-icon-1 clickable" onClick={this.handleClose}></div>
                        </div>
                        <div className="bid-confirmation">
                            <div className="header" style={{ textAlign: 'center' }}>
                                You have selected a Buy Now or Direct Buy item
                            </div>
                            <div className="body-content justify-content-center">
                                {this.state.closeBuyNowIrmButton ? <>
                                    <p className='text-center'> Please select your Item Receipt Method</p>

                                    {

                                        this.state.itemIrm[0] === "pickup" && this.state.itemIrm.length === 1 ?
                                            <Form.Group controlId="pickupOnly" className='body-content'>
                                                <Form.Check custom type="checkbox" className="normal" id="pickupOnly" name="pickupOnly" label="An item you won was designated as Pick Up Only. Please confirm you will pick up the items by clicking the box."
                                                    onChange={(event) => this.onChangeBuynowIrm(event)} />
                                            </Form.Group>
                                            :
                                            <div>
                                                <Form.Group className="d-flex multiple-checkbox center-align mt-3">
                                                    {this.state.itemIrm.map((value, index) => {
                                                        return value && <Form.Check custom type="radio" style={{ marginRight: "10px" }} id={value} name="invoiceItemReceipt" label={this.captializeLetter(value)} value={value ? value : ''} onChange={(event) => this.onChangeBuynowIrm(event)} />
                                                    })}
                                                </Form.Group>
                                            </div>
                                    }
                                </> : null}


                            </div>
                            {
                                this.state.buynowItemReceiptValue !== "" ?
                                    <div className="body-content justify-content-center">
                                        {
                                            this.state.confirmBuyNowIrm && this.state.buynowItemReceiptValue !== 'pickup' ? <>
                                                {
                                                    this.state.buynowItemReceiptValue === 'shipping' ?
                                                        <div className="bid-confirmation text-center text-secondary font-weight-bold ">
                                                            You've Selected Shipping!
                                                        </div> :
                                                        this.state.buynowItemReceiptValue === 'delivery' ?
                                                            <div className="bid-confirmation text-center text-secondary font-weight-bold ">
                                                                You've Selected Delivery!
                                                            </div> : null

                                                }

                                                <div className="bid-confirmation text-center text-muted mt-3">Your item will {this.state.buynowItemReceiptValue === 'shipping' ? "ship" : "be delivered"} to the address listed:</div>

                                                <div className="bid-confirmation text-center mt-3">
                                                    {Object.keys(this.state?.shippingto).map((key) =>
                                                        <p className='font-weight-bold' style={{ wordBreak: 'break-all' }}>{this.state?.shippingto[key]}</p>
                                                    )}
                                                </div>
                                            </> : ''}


                                        {
                                            this.state.confirmBuyNowIrm ? <div className="d-flex align-items-center justify-content-center mt-3 actions">
                                                <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeBuyNowConfirm()}>No, Cancel My Decision</Button>
                                                <Button variant="secondary mx-2" onClick={() => this.confirmBuyNowIrm()}  >
                                                    Yes, Confirm My Decision
                                                </Button>

                                            </div> :
                                                <><div className="d-flex align-items-center justify-content-center">
                                                   {!this.state.disablePaymentMethod && `Please select your Payment Method`}
                                                </div>
                                                    {this.state.showPayment && <div className="d-flex align-items-center justify-content-center mt-4 actions">
                                                        {!this.state.isreturnassurance && !this.state.isdeliveryguarantee ?
                                                            <PayPalScriptProvider options={this.state.payPalConfig.script}>
                                                                <PayPalButtons style={this.state.payPalConfig.buttonStyle} disabled={this.state.paypalbtnDisabled} createOrder={(data, actions) => this.createOrder(data, actions)}
                                                                    onApprove={(data, actions) => this.onApprove(data, actions)} fundingSource={FUNDING.PAYPAL} onCancel={this.onCancel} />
                                                            </PayPalScriptProvider> : ''}
                                                        {!this.state.disablePaymentMethod ? <Button variant="outline-dark btn-white mx-2 modal-button" style={{ width: '270px', borderRadius: '15px', marginBottom: '7px' }} onClick={() => { this.confirmBuyNow("autodebit"); }} disabled={this.state.paymentConfirmBtn}>
                                                            Payment Method on File {' '} {this.state.paymentConfirmLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                        </Button> : ''}
                                                    </div>}
                                                   
                                                    </>

                                        }
                                        {this.state.confirmBuyNowIrm && this.state.buynowItemReceiptValue !== 'pickup' ?
                                            <div className="bid-confirmation text-center mt-3 text-muted " style={{ padding: "0px 5%" }}>
                                                If this is not the address you wish to use, please select cancel and navigate to your
                                                personal account to edit the desired shipping address
                                            </div> : ''
                                        }
                                    </div> : ''}
                        </div>
                        {this.state.buynowItemReceiptValue !== "" && this.state.pickupCheckBox && this.state.payPalMessage && !this.state.isreturnassurance && this.state.showBidPlaceBtn && !this.state.isdeliveryguarantee ?
                            <div style={{ fontSize: '12px' }}>
                                A PayPal account is not required, you will have the option to checkout as a guest.
                            </div> : ''}
                        <div className='pt-3'>
                            {this.returnAssuranceModal("BuyNow")}
                        </div>
                        {
                            this.state.paymentError ?
                                <div className="api-error" style={{ marginTop: "10px" }}>
                                    {this.state.paymentError}
                                </div> :
                                null
                        }
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.deliveryInfoModal} size="lg" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body className='pd-5 modal-resp'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <span className='text-bold'>PROVIDED BY <img className="seel-img-resp" src={`${process.env.PUBLIC_URL}/static/images/seelMain.svg`} alt='seel-icon' /></span>
                            <div className="close-icon" onClick={() => { this.closeSeelInfoModal("deliveryInfoModal") }}>×</div>
                        </div>
                        <div className="body-content d-flex align-items-center justify-content-between flex-row text-center text-muted mt-4 w-100">
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-8'>1 - Click Protect Against</span>
                                <div className='d-flex flex-column text-left'>
                                    <div className="d-flex justify-content-center text-center p-8">
                                        <img src={`${process.env.PUBLIC_URL}/static/images/guarateedDelivery.png`} style={{ width: "30%", margin: "5px  0px 10px 0px" }} alt='guaranteed-delivery-icon' />
                                    </div>
                                    <div className='dg-agent-blog'>
                                        <div className='d-flex gap-2'>
                                            <img className="" style={{ width: '15px' }} src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                            <span>Loss</span>
                                        </div>
                                        <div className='d-flex gap-2'>
                                            <img className="" style={{ width: '15px' }} src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                            <span>Damage</span>
                                        </div>
                                        <div className='d-flex gap-2'>
                                            <img className="" style={{ width: '15px' }} src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                            <span>Theft</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-8'>Instant Resolution</span>
                                <div className="d-flex justify-content-center text-center p-8"><img src={`${process.env.PUBLIC_URL}/static/images/thunder.svg`} style={{ width: "25%" }} alt='thunder-icon' /></div>
                                <div className='p-8'>Instantly resolve your shipment issues and get a refund or replacement with a few clicks.</div>
                            </div>
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-8'>Protect Our Planet</span>
                                <div className="d-flex justify-content-center text-center p-8"><img src={`${process.env.PUBLIC_URL}/static/images/seel.svg`} style={{ width: "30%", padding: "15px 0px 15px 0px" }} alt='seel-icon' /></div>
                                <div className='p-8'>Part of your Delivery Guarantee fee will fund green project to offset emissions from shipping.</div>
                            </div>
                        </div>
                        <div className='mt-4 d-flex align-items-center text-center flex-column'>
                            <p>Delivery Guarantee offers peace of mind against package loss, damage, and theft, while offsetting carbon emissions from shipping for a greener planet. Should any covered incidents occur,
                                use the <a className='cursor' href='https://resolve.seel.com/' target='_blank'><u>Seel Resolution Center</u></a> to resolve your package issue and get compensation up to the full value of your order!</p>
                            <p>*Delivery Guarantee is not available for pickup and delivery item(s).</p>
                        </div>
                        {/* <div className='d-flex mt-4' style={{ justifyContent: "space-evenly" }}>
                            <span className='clickable' onClick={() => { this.navigateToUrl("https://www.seel.com/terms/delivery-guarantee") }}><u>Terms Apply</u></span>
                            <span className='clickable' onClick={() => { this.navigateToUrl("https://www.seel.com/privacy") }}><u>Privacy Policy</u></span>
                        </div> */}
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.returnAssuranceInfoModal} size="lg" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body className='pd-5 modal-resp'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <span className='text-bold'>PROVIDED BY <img className="seel-img-resp" src={`${process.env.PUBLIC_URL}/static/images/seelMain.svg`} alt='seel-icon' /></span>
                            <div className="close-icon" onClick={() => { this.closeSeelInfoModal("returnAssuranceInfoModal") }}>×</div>
                        </div>
                        <div className="body-content d-flex align-items-center justify-content-between flex-row text-center text-muted mt-4 w-100">
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-2 seel-resp'>Return For Any Reason</span>
                                <div className='d-flex flex-column text-left'>
                                    <div className="d-flex justify-content-center text-center p-2">
                                        <img src={`${process.env.PUBLIC_URL}/static/images/MakeItReturnable.png`} style={{ width: "40%" }} alt='make-it-returnable-icon' />
                                    </div>
                                    <div className='return-assurence'>
                                        <div className='d-flex gap-1'>
                                            <img className="w-9 mr-2" src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                            <span>No longer needed</span>
                                        </div>
                                        <div className='d-flex gap-1'>
                                            <img className="w-9 mr-2" src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                            <span>Dissatisfied with items</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-2 seel-resp'>Instant Resolution</span>
                                <div className="d-flex justify-content-center text-center p-2"><img src={`${process.env.PUBLIC_URL}/static/images/shield.svg`} style={{ width: "30%" }} alt='shield-icon' /></div>
                                <div style={{ paddingTop: "19px" }}>Bid with confidence.</div>
                                <div>Make a return within 7 days of Pickup or Shipping.</div>
                            </div>
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-2 seel-resp'>Easy Resolution</span>
                                <div className="d-flex justify-content-center text-center p-2"><img src={`${process.env.PUBLIC_URL}/static/images/thunder.svg`} style={{ width: "25%" }} alt='thunder-icon' /></div>
                                <div className='text-align-center p-2'>Resolve your return request and get refunded with a few clicks.</div>
                            </div>
                        </div>
                        <div className='mt-4 d-flex align-items-center text-center flex-column'>
                            Seel’s Make It Returnable (Return Assurance) are for eligible items from $15 to $1,000. Fees vary. When applicable, sales tax will be included in the price of Make it Returnable. Fees vary.
                        </div>
                        <div className='d-flex mt-4' style={{ justifyContent: "space-evenly" }}>
                            <span className='clickable' onClick={() => { this.navigateToUrl("https://www.seel.com/privacy") }}><u>Privacy Policy</u></span>
                            <span className='clickable' onClick={() => { this.navigateToUrl("https://www.seel.com/terms/delivery-guarantee") }}><u>Terms of Service</u></span>
                        </div>
                    </Modal.Body>
                </Modal>
            </div >
        );
    }
}

export default connect(state => state)(ItemView);